(() => {
  const getAssetName = (url) => {
    try {
      const pathname = new URL(url, window.location.href).pathname;
      return pathname.split('/').pop();
    } catch (error) {
      return '';
    }
  };

  const shouldRemoveNode = (node) => {
    if (!(node instanceof Element)) return false;

    if (node.matches('script[src]')) {
      return getAssetName(node.getAttribute('src')) === 'product.js';
    }

    if (node.matches('link[rel~="stylesheet"][href]')) {
      return getAssetName(node.getAttribute('href')) === 'product.css';
    }

    return false;
  };

  const removeProductAssetNode = (node) => {
    if (shouldRemoveNode(node)) {
      node.remove();
    }
  };

  const cleanupProductAssets = (root = document) => {
    if (root instanceof Document || root instanceof DocumentFragment || root instanceof Element) {
      if (root instanceof Element) {
        removeProductAssetNode(root);
      }

      root.querySelectorAll?.('script[src], link[rel~="stylesheet"][href]').forEach((node) => {
        removeProductAssetNode(node);
      });
    }
  };

  cleanupProductAssets();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        cleanupProductAssets(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

(() => {
  const getVisibleThumbnails = (thumbnailContainer) => {
    return thumbnailContainer ? Array.from(thumbnailContainer.querySelectorAll('.product-thumbnail')).filter((thumbnail) => thumbnail.clientWidth > 0) : [];
  };

  const scrollThumbnailIntoView = (thumbnail) => {
    const scroller = thumbnail?.closest('.product-thumbnail-container');
    if (!scroller) return;

    requestAnimationFrame(() => {
      scroller.scrollTo({
        left: thumbnail.offsetLeft - (scroller.clientWidth / 2) + (thumbnail.clientWidth / 2),
        top: thumbnail.offsetTop - (scroller.clientHeight / 2) + (thumbnail.clientHeight / 2),
        behavior: 'smooth'
      });
    });
  };

  const bootstrapProductSlider = () => {
    if (!window.Flickity) return false;

    const slider = document.querySelector('#opt-main-product product-slider');
    if (!slider) return false;

    let flkty = Flickity.data(slider);
    const hadFlickity = Boolean(flkty);
    if (!flkty) {
      flkty = new Flickity(slider, {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      });

      slider.flkty = flkty;
    }

    flkty.options.draggable = true;
    flkty.updateDraggable();
    flkty.resize();

    const productContainer = slider.closest('.thb-product-detail');
    const thumbnailContainer = productContainer?.querySelector('.product-thumbnail-container');
    const thumbnails = thumbnailContainer ? Array.from(thumbnailContainer.querySelectorAll('.product-thumbnail')) : [];
    const mediaCounter = slider.querySelector('.product-media-counter');
    const mediaCounterCurrent = mediaCounter?.querySelector('.product-media-counter__current');
    const mediaCounterTotal = mediaCounter?.querySelector('.product-media-counter__total');

    const updateCounter = (index) => {
      if (!mediaCounterCurrent || !mediaCounterTotal) return;
      mediaCounterCurrent.textContent = index + 1;
      mediaCounterTotal.textContent = flkty.cells.length;
    };

    const selectThumbnail = (index) => {
      const visibleThumbnails = getVisibleThumbnails(thumbnailContainer);
      const thumbnail = visibleThumbnails[index];
      if (!thumbnail) return;

      thumbnails.forEach((item) => item.classList.remove('is-initial-selected'));
      thumbnail.classList.add('is-initial-selected');
      flkty.select(index);
      scrollThumbnailIntoView(thumbnail);
    };

    const selectAdjacentThumbnail = (direction) => {
      const visibleThumbnails = getVisibleThumbnails(thumbnailContainer);
      if (!visibleThumbnails.length) return;

      const currentThumbnail = thumbnailContainer?.querySelector('.product-thumbnail.is-initial-selected');
      const currentIndex = Math.max(visibleThumbnails.indexOf(currentThumbnail), 0);
      selectThumbnail((currentIndex + direction + visibleThumbnails.length) % visibleThumbnails.length);
    };

    const prevButton = slider.querySelector('.flickity-prev');
    const nextButton = slider.querySelector('.flickity-next');
    const thumbnailPrevButton = productContainer?.querySelector('.product-thumbnail-navigation__button--prev');
    const thumbnailNextButton = productContainer?.querySelector('.product-thumbnail-navigation__button--next');

    if (!hadFlickity && prevButton && prevButton.dataset.optSliderNavBound !== 'true') {
      prevButton.dataset.optSliderNavBound = 'true';
      prevButton.addEventListener('click', () => flkty.previous());
    }

    if (!hadFlickity && nextButton && nextButton.dataset.optSliderNavBound !== 'true') {
      nextButton.dataset.optSliderNavBound = 'true';
      nextButton.addEventListener('click', () => flkty.next());
    }

    if (thumbnailPrevButton && thumbnailPrevButton.dataset.optThumbnailRepairBound !== 'true') {
      thumbnailPrevButton.dataset.optThumbnailRepairBound = 'true';
      thumbnailPrevButton.dataset.productThumbnailBound = 'true';
      thumbnailPrevButton.addEventListener('click', (event) => {
        event.preventDefault();
        selectAdjacentThumbnail(-1);
      });
    }

    if (thumbnailNextButton && thumbnailNextButton.dataset.optThumbnailRepairBound !== 'true') {
      thumbnailNextButton.dataset.optThumbnailRepairBound = 'true';
      thumbnailNextButton.dataset.productThumbnailBound = 'true';
      thumbnailNextButton.addEventListener('click', (event) => {
        event.preventDefault();
        selectAdjacentThumbnail(1);
      });
    }

    getVisibleThumbnails(thumbnailContainer).forEach((thumbnail, index) => {
      if (thumbnail.dataset.optThumbnailRepairBound === 'true') return;

      thumbnail.dataset.optThumbnailRepairBound = 'true';
      thumbnail.addEventListener('click', () => selectThumbnail(index));
    });

    if (slider.dataset.optSliderChangeRepaired !== 'true') {
      slider.dataset.optSliderChangeRepaired = 'true';
      flkty.on('change', (index) => {
        updateCounter(index);
        const visibleThumbnails = getVisibleThumbnails(thumbnailContainer);
        const thumbnail = visibleThumbnails[index] || visibleThumbnails[0];
        thumbnails.forEach((item) => item.classList.remove('is-initial-selected'));
        thumbnail?.classList.add('is-initial-selected');
        scrollThumbnailIntoView(thumbnail);
      });
    }

    updateCounter(flkty.selectedIndex);
    selectThumbnail(flkty.selectedIndex);
    return true;
  };

  const startedAt = Date.now();
  const tick = () => {
    if (bootstrapProductSlider()) return;
    if (Date.now() - startedAt > 4000) return;
    window.requestAnimationFrame(tick);
  };

  tick();
})();

const setOptMoneyHtml = (element, value) => {
  if (!element) return;
  element.innerHTML = String(value ?? '');
};

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `sku-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (destination) destination.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button:not([data-opt-sticky-atc-add])');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button:not([data-opt-sticky-atc-add])');
      const price = document.getElementById(`price-${this.dataset.section}`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('opt-product-variant-config-picker')) {
  class OptProductVariantConfigPicker extends HTMLElement {
    connectedCallback() {
      this.variantGroupName = this.dataset.variantGroupName || 'Model';
      this.cards = Array.from(this.querySelectorAll('[data-variant-config-value]'));
      this.variantChangeHandler = (event) => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.section) return;
        this.sync();
      };
      this.cardClickHandlers = this.cards.map((card) => {
        const handler = () => this.selectValue(card.dataset.variantConfigValue);
        card.addEventListener('click', handler);
        return handler;
      });

      document.addEventListener('product:variant-change', this.variantChangeHandler);
      requestAnimationFrame(() => this.sync());
    }

    disconnectedCallback() {
      this.cards.forEach((card, index) => {
        card.removeEventListener('click', this.cardClickHandlers[index]);
      });
      document.removeEventListener('product:variant-change', this.variantChangeHandler);
    }

    getVariantSelects() {
      return document.getElementById(this.dataset.variantSelectsId);
    }

    getProductScope() {
      return this.closest('.thb-product-detail') || document.getElementById('opt-main-product') || document;
    }

    getProductForm() {
      return document.getElementById(`product-form-${this.dataset.section}`);
    }

    getVariantData() {
      if (this.variantData) return this.variantData;

      const scope = this.getProductScope();
      const sources = [
        this.getVariantSelects()?.querySelector('[type="application/json"]'),
        scope.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]'),
        scope.querySelector('opt-product-sticky-atc [data-opt-sticky-atc-product]')
      ];

      const script = sources.find(Boolean);
      if (!script) {
        this.variantData = [];
        return this.variantData;
      }

      try {
        const data = JSON.parse(script.textContent);
        this.variantData = Array.isArray(data) ? data : data.variants || [];
      } catch (error) {
        console.error(error);
        this.variantData = [];
      }

      return this.variantData;
    }

    getOptionIndex() {
      if (Number.isInteger(this.optionIndex)) return this.optionIndex;

      const fieldset = this.getFieldset();
      const fieldsetIndex = fieldset?.dataset?.index;
      if (fieldsetIndex && /^option\d+$/.test(fieldsetIndex)) {
        this.optionIndex = Number(fieldsetIndex.replace('option', '')) - 1;
        return this.optionIndex;
      }

      const cardValues = this.cards.map((card) => card.dataset.variantConfigValue).filter(Boolean);
      const variants = this.getVariantData();
      const maxOptionCount = Math.max(...variants.map((variant) => (variant.options || []).length), 0);

      for (let index = 0; index < maxOptionCount; index += 1) {
        if (cardValues.some((value) => variants.some((variant) => String(variant.options?.[index]) === String(value)))) {
          this.optionIndex = index;
          return this.optionIndex;
        }
      }

      this.optionIndex = 0;
      return this.optionIndex;
    }

    getFieldset() {
      const variantSelects = this.getVariantSelects();
      if (!variantSelects) return null;

      const optionHandle = this.normalizeOptionName(this.variantGroupName);
      return Array.from(variantSelects.querySelectorAll('fieldset')).find((fieldset) => {
        return this.normalizeOptionName(fieldset.dataset.handle) === optionHandle;
      }) || null;
    }

    normalizeOptionName(value) {
      return String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
    }

    normalizeSku(value) {
      return String(value || '').trim().toLowerCase();
    }

    getControl(value) {
      const fieldset = this.getFieldset();
      if (!fieldset) {
        const scope = this.closest('.thb-product-detail') || document;
        const optionName = this.variantGroupName.replace(/"/g, '\\"');
        const select = scope.querySelector(`select[name="options[${optionName}]"]`);
        if (select) return select;

        return Array.from(scope.querySelectorAll('input[type="radio"]')).find((input) => {
          const inputName = String(input.name || '').toLowerCase();
          const groupName = String(this.variantGroupName || '').toLowerCase();
          return (inputName === groupName || inputName === `options[${groupName}]`)
            && String(input.value) === String(value);
        }) || null;
      }

      const radio = Array.from(fieldset.querySelectorAll('input')).find((input) => input.value === value);
      if (radio) return radio;

      const select = fieldset.querySelector('select');
      return select || null;
    }

    getControlState(control, value) {
      if (!control) {
        return {
          disabled: false,
          selected: false
        };
      }

      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options).find((item) => item.value === value);
        return {
          disabled: Boolean(option?.disabled),
          selected: control.value === value
        };
      }

      return {
        disabled: control.disabled || control.classList.contains('is-disabled'),
        selected: control.checked
      };
    }

    getCurrentValue() {
      const fieldset = this.getFieldset();
      if (!fieldset) {
        const variant = this.getCurrentVariant();
        return variant?.options?.[this.getOptionIndex()] || '';
      }

      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) return checkedInput.value;

      const select = fieldset.querySelector('select');
      return select?.value || '';
    }

    getCurrentVariant() {
      const variantId = this.getProductForm()?.querySelector('[name="id"]')?.value;
      const variants = this.getVariantData();
      return variants.find((variant) => String(variant.id) === String(variantId)) || variants[0] || null;
    }

    getVariantForValue(value) {
      const variants = this.getVariantData();
      const optionIndex = this.getOptionIndex();
      const currentVariant = this.getCurrentVariant();
      const currentOptions = currentVariant?.options || [];

      return variants.find((variant) => {
        if (String(variant.options?.[optionIndex]) !== String(value)) return false;
        return (variant.options || []).every((option, index) => {
          return index === optionIndex || !currentOptions[index] || currentOptions[index] === option;
        });
      }) || variants.find((variant) => String(variant.options?.[optionIndex]) === String(value)) || null;
    }

    updateProductVariant(variant) {
      if (!variant) return;

      const scope = this.getProductScope();
      const productForms = new Set([
        ...document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`),
        ...Array.from(scope.querySelectorAll('form')).filter((form) => form.querySelector('input[name="id"]'))
      ]);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });

      const detail = {
        variant,
        sectionId: this.dataset.section,
        source: this
      };

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('product:variant-change', detail);
      } else {
        document.dispatchEvent(new CustomEvent('product:variant-change', {
          detail,
          bubbles: true
        }));
      }

      document.querySelectorAll('opt-product-sticky-atc').forEach((sticky) => {
        sticky.setVariant?.(variant);
      });
    }

    selectValue(value) {
      const control = this.getControl(value);
      const targetVariant = this.getVariantForValue(value);

      if (!targetVariant || targetVariant.available === false) return;

      if (!control) {
        this.updateProductVariant(targetVariant);
        this.sync();
        return;
      }

      if (this.getControlState(control, value).disabled) return;

      if (control.tagName === 'SELECT') {
        if (control.value === value) {
          this.updateProductVariant(targetVariant);
          this.sync();
          return;
        }
        control.value = value;
        control.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      } else if (!control.checked) {
        control.click();
      }

      window.requestAnimationFrame(() => {
        this.updateProductVariant(targetVariant);
        this.sync();
      });
      this.sync();
    }

    sync() {
      const currentValue = this.getCurrentValue();
      const currentVariant = this.getVariantForValue(currentValue) || this.getCurrentVariant();

      this.cards.forEach((card) => {
        const value = card.dataset.variantConfigValue;
        const control = this.getControl(value);
        const variant = control ? null : this.getVariantForValue(value);
        const state = control ? this.getControlState(control, value) : {
          disabled: variant ? variant.available === false : false,
          selected: currentValue === value
        };
        const isActive = currentValue === value || state.selected;

        card.classList.toggle('is-active', isActive);
        card.classList.toggle('is-disabled', state.disabled);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        card.setAttribute('aria-disabled', state.disabled ? 'true' : 'false');
      });

      if (currentVariant) {
        document.querySelectorAll('opt-product-sticky-atc').forEach((sticky) => {
          sticky.setVariant?.(currentVariant);
        });
      }
    }
  }

  customElements.define('opt-product-variant-config-picker', OptProductVariantConfigPicker);
}

if (!customElements.get('opt-product-package-selector')) {
  class OptProductPackageSelector extends HTMLElement {
    connectedCallback() {
      this.variantGroupName = this.dataset.variantGroupName || 'Plan';
      this.cards = Array.from(this.querySelectorAll('[data-package-option-value]'));
      this.data = this.getData();
      this.configs = this.parsePackageConfig(this.data.rawConfig || '', this.data.newlineToken || '\n');
      this.compareConfigs = this.parseCompareConfig(this.data.compareContent || '');
      this.compareDropdowns = Array.from(this.querySelectorAll('[data-opt-package-compare-dropdown]'));
      this.compareTrigger = this.querySelector('[data-opt-package-compare-trigger]');
      this.giftFetchCache = {};
      this.variantChangeHandler = (event) => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.section) return;
        const isConfigChange = event.detail?.source?.tagName?.toLowerCase() === 'opt-product-variant-config-picker';
        this.sync(event.detail?.variant || null, isConfigChange);
      };
      this.cardClickHandlers = this.cards.map((card) => {
        const handler = () => this.selectValue(card.dataset.packageOptionValue);
        card.addEventListener('click', handler);
        return handler;
      });
      this.giftClickHandler = (event) => this.onGiftClick(event);
      this.giftKeydownHandler = (event) => this.onGiftKeydown(event);
      this.compareOpenHandler = () => this.renderCompareModal(true);
      this.compareClickHandler = (event) => this.onCompareClick(event);
      this.compareDocumentClickHandler = (event) => this.onCompareDocumentClick(event);

      document.addEventListener('product:variant-change', this.variantChangeHandler);
      this.addEventListener('click', this.giftClickHandler);
      this.addEventListener('keydown', this.giftKeydownHandler);
      this.addEventListener('click', this.compareClickHandler);
      document.addEventListener('click', this.compareDocumentClickHandler);
      this.compareTrigger?.addEventListener('click', this.compareOpenHandler);
      requestAnimationFrame(() => this.sync());
      requestAnimationFrame(() => this.renderCompareModal());
      this.loadMissingGifts();
    }

    disconnectedCallback() {
      this.cards.forEach((card, index) => {
        card.removeEventListener('click', this.cardClickHandlers[index]);
      });
      document.removeEventListener('product:variant-change', this.variantChangeHandler);
      this.removeEventListener('click', this.giftClickHandler);
      this.removeEventListener('keydown', this.giftKeydownHandler);
      this.removeEventListener('click', this.compareClickHandler);
      document.removeEventListener('click', this.compareDocumentClickHandler);
      this.compareTrigger?.removeEventListener('click', this.compareOpenHandler);
    }

    getData() {
      const script = this.querySelector('[data-opt-package-data]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error(error);
        return {};
      }
    }

    normalizeOptionName(value) {
      return String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
    }

    normalizeSku(value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    getVariantSelects() {
      const direct = document.getElementById(this.dataset.variantSelectsId);
      if (direct) return direct;

      const productDetail = this.closest('.thb-product-detail') || document;
      return Array.from(productDetail.querySelectorAll('variant-selects, variant-radios')).find((selector) => {
        return !selector.dataset.section || selector.dataset.section === this.dataset.section;
      }) || null;
    }

    getFieldsets() {
      const variantSelects = this.getVariantSelects();
      return variantSelects ? Array.from(variantSelects.querySelectorAll('fieldset')) : [];
    }

    getFieldset() {
      const optionHandle = this.normalizeOptionName(this.variantGroupName);
      return this.getFieldsets().find((fieldset) => {
        return this.normalizeOptionName(fieldset.dataset.handle) === optionHandle;
      }) || null;
    }

    getControl(value) {
      const fieldset = this.getFieldset();
      if (!fieldset) {
        const scope = this.closest('.thb-product-detail') || document;
        const optionName = String(this.variantGroupName || '').replace(/"/g, '\\"');
        const select = scope.querySelector(`select[name="options[${optionName}]"]`);
        if (select) return select;

        return Array.from(scope.querySelectorAll('input[type="radio"]')).find((input) => {
          return String(input.name || '').toLowerCase() === String(this.variantGroupName || '').toLowerCase()
            && String(input.value) === String(value);
        }) || null;
      }

      const radio = Array.from(fieldset.querySelectorAll('input')).find((input) => String(input.value) === String(value));
      if (radio) return radio;

      return fieldset.querySelector('select');
    }

    getControlState(control, value) {
      if (!control) {
        return {
          disabled: false,
          selected: false
        };
      }

      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options).find((item) => item.value === value);
        return {
          disabled: Boolean(option?.disabled),
          selected: control.value === value
        };
      }

      return {
        disabled: control.disabled || control.classList.contains('is-disabled'),
        selected: control.checked
      };
    }

    getSelectedOptions() {
      const fieldsets = this.getFieldsets();
      if (fieldsets.length) {
        return fieldsets.map((fieldset) => {
          const checkedInput = fieldset.querySelector('input:checked');
          if (checkedInput) return checkedInput.value;

          const select = fieldset.querySelector('select');
          return select?.value || '';
        });
      }

      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const variantId = form?.querySelector('input[name="id"]')?.value;
      const selectedVariant = (this.data.variants || []).find((variant) => String(variant.id) === String(variantId));
      if (selectedVariant?.options) return [...selectedVariant.options];

      return (this.data.variants?.[0]?.options || []).map((option) => option || '');
    }

    getCurrentValue() {
      return this.getSelectedOptions()[this.data.targetOptionIndex] || '';
    }

    getProductScope() {
      return this.closest('.thb-product-detail') || document.getElementById('opt-main-product') || document;
    }

    getProductForm() {
      return document.getElementById(`product-form-${this.dataset.section}`);
    }

    getCurrentVariant() {
      const form = this.getProductForm();
      const variantId = form?.querySelector('input[name="id"]')?.value;
      return (this.data.variants || []).find((variant) => String(variant.id) === String(variantId)) || (this.data.variants || [])[0] || null;
    }

    getActiveVariantConfigSelection() {
      const scope = this.closest('.thb-product-detail') || document.getElementById('opt-main-product') || document;
      const configPicker = Array.from(scope.querySelectorAll('opt-product-variant-config-picker')).find((picker) => {
        return !picker.dataset.section || picker.dataset.section === this.dataset.section;
      });
      const activeCard = configPicker?.querySelector('[data-variant-config-value].is-active');
      const optionIndex = configPicker?.getOptionIndex?.();

      if (!activeCard || !Number.isInteger(optionIndex)) return null;

      return {
        optionIndex,
        value: activeCard.dataset.variantConfigValue || ''
      };
    }

    isCompatibleWithActiveVariantConfig(packageValue, configSelection) {
      if (!configSelection?.value) return true;

      return (this.data.variants || []).some((variant) => {
        return String(variant.options?.[this.data.targetOptionIndex] || '') === String(packageValue)
          && String(variant.options?.[configSelection.optionIndex] || '') === String(configSelection.value);
      });
    }

    getCompatibleVariant(packageValue, configSelection) {
      const matches = (variant) => {
        return String(variant.options?.[this.data.targetOptionIndex] || '') === String(packageValue)
          && (!configSelection?.value
            || String(variant.options?.[configSelection.optionIndex] || '') === String(configSelection.value));
      };

      return (this.data.variants || []).find((variant) => matches(variant) && variant.available)
        || (this.data.variants || []).find(matches)
        || null;
    }

    setControlValue(value) {
      const control = this.getControl(value);
      if (!control) return;

      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options).find((item) => String(item.value) === String(value));
        if (!option) return;
        option.disabled = false;
        control.value = value;
        return;
      }

      control.disabled = false;
      control.classList.remove('is-disabled');
      control.checked = true;
    }

    updateProductVariant(variant) {
      if (!variant) return;

      const scope = this.getProductScope();
      const productForms = new Set([
        ...document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`),
        ...Array.from(scope.querySelectorAll('form')).filter((form) => form.querySelector('input[name="id"]'))
      ]);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });

      const detail = {
        variant,
        sectionId: this.dataset.section,
        source: this
      };

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('product:variant-change', detail);
      } else {
        document.dispatchEvent(new CustomEvent('product:variant-change', {
          detail,
          bubbles: true
        }));
      }
    }

    getVariantForValue(value) {
      const selectedOptions = this.getSelectedOptions();
      selectedOptions[this.data.targetOptionIndex] = value;
      const matches = (variant) => selectedOptions.every((option, index) => {
        return !option || String(variant.options?.[index] || '') === String(option);
      });
      const matchesValue = (variant) => {
        return String(variant.options?.[this.data.targetOptionIndex] || '') === String(value);
      };

      return (this.data.variants || []).find((variant) => matches(variant) && variant.available)
        || (this.data.variants || []).find((variant) => matchesValue(variant) && variant.available)
        || (this.data.variants || []).find(matches)
        || (this.data.variants || []).find(matchesValue)
        || null;
    }

    selectValue(value) {
      const control = this.getControl(value);
      const variant = this.getVariantForValue(value);
      if (!control || (variant && !variant.available)) return;

      if (control.tagName === 'SELECT') {
        const option = Array.from(control.options).find((item) => String(item.value) === String(value));
        if (!option) return;
        option.disabled = false;
        if (String(control.value) === String(value)) {
          this.sync();
          return;
        }
        control.value = value;
        control.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      } else {
        control.disabled = false;
        control.classList.remove('is-disabled');
        if (!control.checked) control.click();
        else control.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }

      this.sync();
    }

    parsePackageConfig(rawConfig, separator) {
      const configs = {};
      let currentSku = '';
      const lines = String(rawConfig || '')
        .split(separator)
        .map((line) => line.replace(/^[\s·•\-]+/, '').trim())
        .map((line) => line.replace(/^[\s\u2022\u00b7\u25aa\u25cf\u25e6\u2013\u2014\-*]+/, '').trim())
        .filter(Boolean);

      lines.forEach((line) => {
        if (!line.includes(':')) {
          currentSku = line;
          const configKey = this.normalizeSku(currentSku);
          configs[configKey] = configs[configKey] || {
            tags: [],
            subtitles: [],
            products: []
          };
          return;
        }

        if (!currentSku) return;

        const [rawKey, ...rest] = line.split(':');
        const key = rawKey.trim().toLowerCase();
        const value = rest.join(':').trim();
        if (!value) return;
        const configKey = this.normalizeSku(currentSku);

        if (key === 'tags') {
          configs[configKey].tags = value.split(',').map((tag) => {
            const parts = tag.split('|');
            return {
              style: (parts[0] || '').trim().toLowerCase(),
              text: (parts[1] || parts[0] || '').trim()
            };
          }).filter((tag) => tag.text);
        } else if (key === 'subtitle') {
          configs[configKey].subtitles.push(value);
        } else if (key === 'product') {
          const parts = value.split('|');
          const productHandle = this.handleize(parts[0] || '');
          const modifiers = parts.slice(1).map((part) => part.trim()).filter(Boolean);
          const discountValue = [...modifiers].reverse().find((part) => /%$/.test(part) || /^\d+(\.\d+)?$/.test(part)) || '';
          let defaultSku = '';
          const showSku = modifiers.some((part) => {
            const [rawShowSku, rawDefaultSku = ''] = part.split(',');
            const normalized = rawShowSku.trim().toLowerCase();
            const isShowSku = ['show sku', 'show_sku'].includes(normalized);
            if (isShowSku && rawDefaultSku.trim()) defaultSku = rawDefaultSku.trim();
            return isShowSku;
          });
          const label = modifiers.find((part) => {
            const normalized = part.split(',')[0].trim().toLowerCase();
            return normalized !== 'show sku' && normalized !== 'show_sku' && part !== discountValue;
          }) || '';
          configs[configKey].products.push({
            title: productHandle,
            lookupKey: productHandle,
            label,
            showSku,
            defaultSku,
            discount: discountValue ? Number(String(discountValue).replace('%', '').trim()) || 0 : 0
          });
        }
      });

      return configs;
    }

    parseCompareConfig(rawHtml) {
      const configs = {};
      let currentSku = '';
      const createConfig = (sku) => {
        const key = this.normalizeSku(String(sku || '').replace(/^sku\s*[:：]/i, ''));
        if (!key) return null;
        configs[key] = configs[key] || {
          items: []
        };
        return configs[key];
      };
      const addItem = (text) => {
        const config = createConfig(currentSku);
        if (!config) return;
        const parts = String(text || '').split('|').map((part) => part.trim());
        const title = parts[0] || '';
        if (!title) return;
        config.items.push({
          title,
          quantity: parts[1] || '',
          image: parts.slice(2).join('|').trim()
        });
      };
      const handleTextNode = (text, isListItem = false) => {
        const value = String(text || '').replace(/\s+/g, ' ').trim();
        if (!value) return;
        if (isListItem || value.includes('|')) {
          addItem(value);
          return;
        }
        currentSku = value.replace(/^sku\s*[:：]/i, '').trim();
        createConfig(currentSku);
      };

      if (!rawHtml) return configs;

      try {
        const doc = new DOMParser().parseFromString(String(rawHtml), 'text/html');
        const walk = (node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          const tagName = node.tagName.toLowerCase();
          if (tagName === 'li') {
            handleTextNode(node.textContent, true);
            return;
          }

          if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
            handleTextNode(node.textContent, false);
            return;
          }

          Array.from(node.children).forEach((child) => walk(child));
        };

        Array.from(doc.body.children).forEach((child) => walk(child));
      } catch (error) {
        String(rawHtml || '')
          .replace(/<\/p>|<\/li>|<br\s*\/?>/gi, '\n')
          .replace(/<[^>]+>/g, '')
          .split(/\n+/)
          .map((line) => line.trim())
          .filter(Boolean)
          .forEach((line) => handleTextNode(line, line.includes('|')));
      }

      return configs;
    }

    getCompareOptionValues() {
      return this.cards.map((card) => card.dataset.packageOptionValue).filter(Boolean);
    }

    getCompareDefaults() {
      const values = this.getCompareOptionValues();
      const currentValue = this.getCurrentValue();
      const currentIndex = values.indexOf(currentValue);
      const first = currentIndex >= 0 ? currentValue : values[0] || '';
      const second = values[currentIndex + 1] || values.find((value) => value !== first) || first;
      return [first, second];
    }

    getCompareVariant(value) {
      return this.getVariantForValue(value) || (this.data.variants || []).find((variant) => {
        return String(variant.options?.[this.data.targetOptionIndex] || '') === String(value);
      }) || null;
    }

    getCompareConfig(variant, value) {
      return this.compareConfigs[this.normalizeSku(variant?.sku)]
        || this.compareConfigs[this.normalizeSku(value)]
        || {
          items: []
        };
    }

    closeCompareDropdowns(except = null) {
      this.compareDropdowns.forEach((dropdown) => {
        if (dropdown === except) return;
        dropdown.classList.remove('is-open');
        dropdown.querySelector('[data-opt-package-compare-dropdown-button]')?.setAttribute('aria-expanded', 'false');
        const panel = dropdown.querySelector('[data-opt-package-compare-dropdown-panel]');
        if (panel) panel.hidden = true;
      });
    }

    renderCompareModal(resetSelections = false) {
      if (!this.compareDropdowns.length) return;

      const defaults = this.getCompareDefaults();
      this.compareDropdowns.forEach((dropdown, index) => {
        const options = Array.from(dropdown.querySelectorAll('[data-opt-package-compare-dropdown-option]'));
        const button = dropdown.querySelector('[data-opt-package-compare-dropdown-button]');
        const label = dropdown.querySelector('[data-opt-package-compare-dropdown-label]');
        const values = options.map((option) => option.dataset.optionValue || '');
        let selectedValue = dropdown.dataset.optPackageCompareValue || '';
        if (resetSelections || !selectedValue || !values.includes(selectedValue) || !dropdown.dataset.optPackageCompareInitialized) {
          selectedValue = defaults[index] || values[index] || values[0] || '';
          dropdown.dataset.optPackageCompareInitialized = 'true';
        }
        dropdown.dataset.optPackageCompareValue = selectedValue;
        if (label) label.textContent = selectedValue || button?.textContent || '';
        options.forEach((option) => {
          const isSelected = option.dataset.optionValue === selectedValue;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        this.renderCompareColumn(index, selectedValue);
      });
    }

    renderCompareColumn(index, value) {
      const column = this.querySelector(`[data-opt-package-compare-column="${index}"]`);
      const list = this.querySelector(`[data-opt-package-compare-list="${index}"]`);
      if (!column || !list) return;

      const variant = this.getCompareVariant(value);
      const config = this.getCompareConfig(variant, value);
      const imageWrap = column.querySelector('[data-opt-package-compare-image-wrap]');
      const title = column.querySelector('[data-opt-package-compare-title]');
      const price = column.querySelector('[data-opt-package-compare-price]');
      const compare = column.querySelector('[data-opt-package-compare-compare]');
      const image = variant?.compareImage || variant?.image || '';

      if (imageWrap) {
        imageWrap.innerHTML = image ? `<img src="${this.escapeHtml(image)}" alt="" loading="lazy">` : '';
      }
      if (title) {
        title.textContent = value || variant?.title || '';
      }
      if (price) {
        setOptMoneyHtml(price, variant?.price || '');
      }
      if (compare) {
        setOptMoneyHtml(compare, variant?.comparePrice || '');
        compare.hidden = !variant?.comparePrice;
      }

      const items = config.items || [];
      list.innerHTML = items.length ? items.map((item) => this.renderCompareItem(item)).join('') : '';
    }

    onCompareClick(event) {
      const button = event.target.closest('[data-opt-package-compare-dropdown-button]');
      if (button && this.contains(button)) {
        event.preventDefault();
        event.stopPropagation();
        const dropdown = button.closest('[data-opt-package-compare-dropdown]');
        if (!dropdown) return;
        const isOpen = dropdown.classList.contains('is-open');
        this.closeCompareDropdowns(dropdown);
        dropdown.classList.toggle('is-open', !isOpen);
        button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        const panel = dropdown.querySelector('[data-opt-package-compare-dropdown-panel]');
        if (panel) panel.hidden = isOpen;
        return;
      }

      const option = event.target.closest('[data-opt-package-compare-dropdown-option]');
      if (option && this.contains(option)) {
        event.preventDefault();
        event.stopPropagation();
        const dropdown = option.closest('[data-opt-package-compare-dropdown]');
        if (!dropdown) return;
        const value = option.dataset.optionValue || '';
        dropdown.dataset.optPackageCompareValue = value;
        dropdown.classList.remove('is-open');
        dropdown.querySelector('[data-opt-package-compare-dropdown-button]')?.setAttribute('aria-expanded', 'false');
        dropdown.querySelector('[data-opt-package-compare-dropdown-panel]')?.setAttribute('hidden', '');
        this.renderCompareModal(false);
      }
    }

    onCompareDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeCompareDropdowns();
      }
    }

    renderCompareItem(item) {
      const image = item.image || '';
      return `
        <div class="opt-product-package-selector__compare-item">
          <span class="opt-product-package-selector__compare-item-image">${image ? `<img src="${this.escapeHtml(image)}" alt="" loading="lazy">` : ''}</span>
          <span class="opt-product-package-selector__compare-item-copy">
            <span class="opt-product-package-selector__compare-item-title">${this.escapeHtml(item.title)}</span>
            ${item.quantity ? `<span class="opt-product-package-selector__compare-item-quantity">${this.escapeHtml(item.quantity)}</span>` : ''}
          </span>
        </div>
      `;
    }

    handleize(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/['"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    getConfiguredGiftHandles() {
      const handles = [];
      Object.values(this.configs || {}).forEach((config) => {
        (config.products || []).forEach((product) => {
          const handle = this.handleize(product.lookupKey || product.title || '');
          if (handle && !handles.includes(handle)) handles.push(handle);
        });
      });
      return handles;
    }

    hasGift(handle) {
      return (this.data.gifts || []).some((gift) => {
        return gift.lookupKey === handle || this.handleize(gift.title) === handle;
      });
    }

    getProductJsonUrl(handle) {
      const rootUrl = typeof theme !== 'undefined' && theme.routes?.root_url ? theme.routes.root_url : '/';
      return `${String(rootUrl).replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`;
    }

    getProductImage(value) {
      if (!value) return null;
      if (typeof value === 'string') return value;
      return value.src || value.url || null;
    }

    getProductVariantOptions(variant) {
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(Boolean);
    }

    normalizeGiftProduct(product, handle) {
      const variants = (product.variants || []).map((variant) => {
        const image = this.getProductImage(variant.featured_image) || this.getProductImage(product.featured_image) || this.getProductImage((product.images || [])[0]);
        const priceCents = Number(variant.price || 0);
        return {
          id: variant.id,
          available: variant.available !== false,
          sku: variant.sku || '',
          title: variant.public_title || variant.title || '',
          options: this.getProductVariantOptions(variant),
          priceCents,
          price: this.formatMoneyFromCents(priceCents, ''),
          image
        };
      });
      const selectedVariant = variants.find((variant) => variant.available) || variants[0];
      const options = (product.options || []).map((option) => typeof option === 'string' ? option : option.name).filter(Boolean);

      if (!selectedVariant) return null;

      return {
        lookupKey: handle,
        title: product.title || handle,
        variantId: selectedVariant.id,
        sku: selectedVariant.sku || '',
        priceCents: selectedVariant.priceCents || 0,
        price: selectedVariant.price || '',
        image: this.getProductImage(product.featured_image) || this.getProductImage((product.images || [])[0]) || selectedVariant.image,
        options,
        variants
      };
    }

    async fetchGiftProduct(handle) {
      if (this.giftFetchCache[handle]) return this.giftFetchCache[handle];

      this.giftFetchCache[handle] = fetch(this.getProductJsonUrl(handle))
        .then((response) => response.ok ? response.json() : null)
        .then((product) => product ? this.normalizeGiftProduct(product, handle) : null)
        .catch(() => null);

      return this.giftFetchCache[handle];
    }

    async loadMissingGifts() {
      const missingHandles = this.getConfiguredGiftHandles().filter((handle) => !this.hasGift(handle));
      if (!missingHandles.length) return;

      const gifts = (await Promise.all(missingHandles.map((handle) => this.fetchGiftProduct(handle)))).filter(Boolean);
      if (!gifts.length) return;

      this.data.gifts = [...(this.data.gifts || []), ...gifts.filter((gift) => !this.hasGift(gift.lookupKey))];
      this.sync();
    }

    escapeHtml(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character]));
    }

    formatMoneyFromCents(cents, fallback) {
      if (typeof cents !== 'number') return fallback || '';

      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        const moneyFormat = typeof theme !== 'undefined' ? theme.money_format : '${{amount}}';
        return Shopify.formatMoney(cents, moneyFormat || '${{amount}}').replace(' USD', '');
      }

      return `$${(cents / 100).toFixed(0)}`;
    }

    getGiftVariant(gift, selectedId, defaultSku = '') {
      const variants = gift.variants || [];
      return variants.find((variant) => String(variant.id) === String(selectedId))
        || variants.find((variant) => defaultSku && String(variant.sku || '').trim() === String(defaultSku).trim())
        || variants.find((variant) => variant.available)
        || variants[0]
        || gift;
    }

    renderGiftSkuSelector(gift, selectedVariant, disabled = false) {
      const variants = gift.variants || [];
      const hasSelectableSku = variants.length > 1 && !variants.every((variant) => variant.title === 'Default Title');
      if (!hasSelectableSku) return '';

      const selectedLabel = selectedVariant?.options?.join(' / ') || selectedVariant?.title || '';
      const selectedOptions = selectedVariant?.options || [];
      const optionGroups = (gift.options || []).map((optionName, optionIndex) => {
        const values = [...new Set(variants.map((variant) => variant.options?.[optionIndex]).filter(Boolean))];

        return `
          <span class="opt-product-package-selector__gift-sku-group">
            <span class="opt-product-package-selector__gift-sku-label">${this.escapeHtml(optionName)}</span>
            <span class="opt-product-package-selector__gift-sku-list">
              ${values.map((value) => {
                const nextOptions = [...selectedOptions];
                nextOptions[optionIndex] = value;
                const matchedVariant = variants.find((variant) => nextOptions.every((option, index) => !option || variant.options?.[index] === option));
                const available = matchedVariant ? matchedVariant.available : variants.some((variant) => variant.options?.[optionIndex] === value && variant.available);

                return `
                  <button
                    class="opt-product-package-selector__gift-sku-option${selectedOptions[optionIndex] === value ? ' is-selected' : ''}"
                    type="button"
                    data-opt-package-gift-sku-option
                    data-option-index="${optionIndex}"
                    data-option-value="${this.escapeHtml(value)}"
                    aria-pressed="${selectedOptions[optionIndex] === value ? 'true' : 'false'}"
                    ${available ? '' : 'aria-disabled="true"'}
                  >
                    ${this.escapeHtml(value)}
                  </button>
                `;
              }).join('')}
            </span>
          </span>
        `;
      }).join('');

      return `
        <span class="opt-product-package-selector__gift-sku${disabled ? ' is-disabled' : ''}" data-opt-package-gift-sku${disabled ? ' data-opt-package-gift-sku-disabled="true"' : ''}>
          <button class="opt-product-package-selector__gift-sku-button" type="button" aria-expanded="false" data-opt-package-gift-sku-button${disabled ? ' disabled aria-disabled="true"' : ''}>
            <span data-opt-package-gift-sku-label>${this.escapeHtml(selectedLabel)}</span>
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <span class="opt-product-package-selector__gift-sku-panel" data-opt-package-gift-sku-panel>
            ${optionGroups}
          </span>
        </span>
      `;
    }

    renderCard(card, variant, config, isActive) {
      const cardShell = card.closest('[data-package-card]') || card.parentElement;
      const imageWrap = card.querySelector('[data-opt-package-image-wrap]');
      const price = card.querySelector('[data-opt-package-price]');
      const compare = card.querySelector('[data-opt-package-compare]');
      const tags = card.querySelector('[data-opt-package-tags]');
      const descriptions = card.querySelector('[data-opt-package-descriptions]');
      const gifts = cardShell?.querySelector('[data-opt-package-gifts]');
      const details = card.querySelector('[data-opt-package-details]');

      if (imageWrap) {
        imageWrap.innerHTML = variant?.image ? `<img src="${this.escapeHtml(variant.image)}" alt="" width="56" height="56" loading="lazy">` : '';
      }

      if (price) setOptMoneyHtml(price, variant?.price || '');
      if (compare) {
        setOptMoneyHtml(compare, variant?.comparePrice || '');
        compare.hidden = !variant?.comparePrice;
      }

      if (tags) {
        tags.innerHTML = (config.tags || []).map((tag) => {
          const style = ['pink', 'yellow', 'orange', 'red'].includes(tag.style) ? tag.style : 'pink';
          return `<span class="opt-product-package-selector__tag opt-product-package-selector__tag--${style}">${this.escapeHtml(tag.text)}</span>`;
        }).join('');
        tags.hidden = !config.tags?.length;
      }

      if (descriptions) {
        descriptions.innerHTML = (config.subtitles || []).map((subtitle) => {
          return `<span class="opt-product-package-selector__description">${this.escapeHtml(subtitle)}</span>`;
        }).join('');
        descriptions.hidden = !config.subtitles?.length;
      }

      if (gifts) {
        const giftHtml = (config.products || []).map((item) => this.renderGift(item)).filter(Boolean).join('');
        gifts.innerHTML = giftHtml;
        gifts.hidden = !isActive || !giftHtml;
      }

      if (details) {
        details.hidden = !isActive || !((config.subtitles || []).length || (config.products || []).length);
      }
    }

    renderGift(item) {
      const gift = (this.data.gifts || []).find((product) => {
        return product.lookupKey === item.lookupKey || product.title === item.title;
      });
      if (!gift || !gift.variantId) return '';

      const selectedVariant = this.getGiftVariant(gift, null, item.defaultSku);
      const discount = Math.min(Math.max(item.discount || 0, 0), 100);
      const discountedCents = Math.round((selectedVariant.priceCents || 0) * (100 - discount) / 100);
      const displayedPrice = this.formatMoneyFromCents(discountedCents, selectedVariant.price || gift.price);
      const comparePrice = discount > 0 ? selectedVariant.price || gift.price : '';
      const showSku = item.showSku && (gift.variants || []).length > 1;
      const defaultSkuMatched = Boolean(item.defaultSku) && String(selectedVariant.sku || '').trim() === String(item.defaultSku).trim();
      const disableSku = showSku && defaultSkuMatched;
      const giftImage = selectedVariant.image || gift.image;

      return `
        <span class="opt-product-package-selector__gift is-selected" data-opt-package-gift data-opt-package-gift-selected="true" role="checkbox" aria-checked="true" tabindex="0">
          <span class="opt-product-package-selector__checkbox" aria-hidden="true">
            <svg viewBox="0 0 10.113 7.43434" fill="none"><path d="M8.83581 0.146447C9.03107 -0.0488155 9.34758 -0.0488155 9.54284 0.146447L9.96667 0.570275C10.1617 0.765555 10.1619 1.08212 9.96667 1.27731L3.95593 7.28805C3.76073 7.48314 3.44414 7.48306 3.2489 7.28805L3.16393 7.20309C3.09506 7.17913 3.02954 7.14184 2.97448 7.08688L0.146356 4.25875C-0.0488457 4.06355 -0.048725 3.747 0.146356 3.55172L0.570184 3.12789C0.765446 2.93263 1.08195 2.93263 1.27722 3.12789L3.5653 5.41598L8.83581 0.146447Z" fill="currentColor"/></svg>
          </span>
          <span class="opt-product-package-selector__gift-image">${giftImage ? `<img src="${this.escapeHtml(giftImage)}" alt="" width="56" height="56" loading="lazy" data-opt-package-gift-image>` : ''}</span>
          <span class="opt-product-package-selector__gift-content${showSku ? ' opt-product-package-selector__gift-content--has-sku' : ''}">
            <span class="opt-product-package-selector__gift-heading">
              ${item.label ? `<span class="opt-product-package-selector__gift-label">${this.escapeHtml(item.label)}</span>` : ''}
              <span class="opt-product-package-selector__gift-title">${this.escapeHtml(gift.title)} x 1</span>
            </span>
            ${showSku ? this.renderGiftSkuSelector(gift, selectedVariant, disableSku) : ''}
          </span>
          <span class="opt-product-package-selector__gift-prices">
            <span class="opt-product-package-selector__gift-price">${displayedPrice}</span>
            ${comparePrice ? `<span class="opt-product-package-selector__gift-compare">${comparePrice}</span>` : ''}
          </span>
          <span hidden data-opt-package-gift-variant-id="${this.escapeHtml(selectedVariant.id || gift.variantId)}" data-opt-package-gift-discount="${discount}"></span>
        </span>
      `;
    }

    setGiftSelected(giftRow, selected) {
      giftRow.dataset.optPackageGiftSelected = selected ? 'true' : 'false';
      giftRow.classList.toggle('is-selected', selected);
      giftRow.setAttribute('aria-checked', selected ? 'true' : 'false');
      giftRow.dispatchEvent(new CustomEvent('opt-package-gift-change', {
        bubbles: true
      }));
      this.notifyChange({
        reason: 'gift-selection',
        giftRow
      });
    }

    onGiftClick(event) {
      const skuButton = event.target.closest('[data-opt-package-gift-sku-button]');
      if (skuButton) {
        event.preventDefault();
        event.stopPropagation();
        const sku = skuButton.closest('[data-opt-package-gift-sku]');
        if (sku?.dataset.optPackageGiftSkuDisabled === 'true' || skuButton.disabled) return;
        const isOpen = sku?.classList.contains('is-open');
        this.querySelectorAll('[data-opt-package-gift-sku].is-open').forEach((item) => {
          if (item !== sku) {
            item.classList.remove('is-open');
            item.querySelector('[data-opt-package-gift-sku-button]')?.setAttribute('aria-expanded', 'false');
          }
        });
        sku?.classList.toggle('is-open', !isOpen);
        skuButton.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        return;
      }

      const skuOption = event.target.closest('[data-opt-package-gift-sku-option]');
      if (!skuOption) {
        if (event.target.closest('[data-opt-package-gift-sku]')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const giftRow = event.target.closest('[data-opt-package-gift]');
        if (!giftRow) return;

        event.preventDefault();
        event.stopPropagation();
        this.setGiftSelected(giftRow, giftRow.dataset.optPackageGiftSelected !== 'true');
        return;
      }

      if (skuOption.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopPropagation();

      const giftRow = skuOption.closest('[data-opt-package-gift]');
      const optionIndex = Number(skuOption.dataset.optionIndex);
      const optionValue = skuOption.dataset.optionValue;
      const currentVariantId = giftRow?.querySelector('[data-opt-package-gift-variant-id]')?.dataset.optPackageGiftVariantId;
      const gift = (this.data.gifts || []).find((product) => {
        return (product.variants || []).some((variant) => String(variant.id) === String(currentVariantId));
      });
      if (!gift) return;

      const currentVariant = this.getGiftVariant(gift, currentVariantId);
      const nextOptions = [...(currentVariant.options || [])];
      nextOptions[optionIndex] = optionValue;
      const variant = (gift.variants || []).find((variantItem) => {
        return nextOptions.every((option, index) => !option || variantItem.options?.[index] === option);
      }) || (gift.variants || []).find((variantItem) => variantItem.options?.[optionIndex] === optionValue) || currentVariant;
      const hidden = giftRow?.querySelector('[data-opt-package-gift-variant-id]');
      const label = giftRow?.querySelector('[data-opt-package-gift-sku-label]');
      const image = giftRow?.querySelector('[data-opt-package-gift-image]');
      const price = giftRow?.querySelector('.opt-product-package-selector__gift-price');
      const compare = giftRow?.querySelector('.opt-product-package-selector__gift-compare');
      const discount = Number(hidden?.dataset.optPackageGiftDiscount || 0);
      const discountedCents = Math.round((variant.priceCents || 0) * (100 - discount) / 100);

      if (hidden) hidden.dataset.optPackageGiftVariantId = variant.id;
      if (label) label.textContent = variant.options?.join(' / ') || variant.title || '';
      if (image && variant.image) image.src = variant.image;
      if (price) setOptMoneyHtml(price, this.formatMoneyFromCents(discountedCents, variant.price));
      if (compare && discount > 0) setOptMoneyHtml(compare, variant.price || '');

      skuOption.closest('[data-opt-package-gift-sku]')?.classList.remove('is-open');
      skuOption.closest('[data-opt-package-gift-sku]')?.querySelector('[data-opt-package-gift-sku-button]')?.setAttribute('aria-expanded', 'false');
      Array.from(skuOption.closest('[data-opt-package-gift-sku-panel]')?.querySelectorAll('[data-opt-package-gift-sku-option]') || []).forEach((option) => {
        const index = Number(option.dataset.optionIndex);
        const isSelected = variant.options?.[index] === option.dataset.optionValue;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      this.notifyChange({
        reason: 'gift-sku',
        giftRow,
        variant
      });
    }

    onGiftKeydown(event) {
      const giftRow = event.target.closest('[data-opt-package-gift]');
      if (!giftRow || event.target.closest('[data-opt-package-gift-sku]')) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      this.setGiftSelected(giftRow, giftRow.dataset.optPackageGiftSelected !== 'true');
    }

    sync(currentVariant = null, selectFirstCompatiblePackage = false) {
      const configSelection = this.getActiveVariantConfigSelection();
      let currentValue = currentVariant?.options?.[this.data.targetOptionIndex] || this.getCurrentValue();

      if (selectFirstCompatiblePackage) {
        const firstCompatibleCard = this.cards.find((card) => {
          return this.isCompatibleWithActiveVariantConfig(card.dataset.packageOptionValue, configSelection);
        });
        const firstCompatibleValue = firstCompatibleCard?.dataset.packageOptionValue;
        const firstCompatibleVariant = firstCompatibleValue
          ? this.getCompatibleVariant(firstCompatibleValue, configSelection)
          : null;

        if (firstCompatibleVariant && currentValue !== firstCompatibleValue) {
          this.setControlValue(firstCompatibleValue);
          this.updateProductVariant(firstCompatibleVariant);
          return;
        }

        if (firstCompatibleValue) {
          currentValue = firstCompatibleValue;
          currentVariant = firstCompatibleVariant || currentVariant;
        }
      }
      let activeVariant = null;

      this.cards.forEach((card) => {
        const value = card.dataset.packageOptionValue;
        const cardShell = card.closest('[data-package-card]') || card.parentElement;
        const control = this.getControl(value);
        const state = this.getControlState(control, value);
        const isCompatible = this.isCompatibleWithActiveVariantConfig(value, configSelection);
        const isActive = isCompatible && currentValue === value;
        const eventVariant = currentVariant ? (this.data.variants || []).find((variantItem) => String(variantItem.id) === String(currentVariant.id)) : null;
        const variant = isActive && eventVariant ? eventVariant : this.getVariantForValue(value);
        const config = this.configs[this.normalizeSku(variant?.sku)] || {
          tags: [],
          subtitles: [],
          products: []
        };

        card.classList.toggle('is-active', isActive);
        cardShell?.classList.toggle('is-active', isActive);
        if (cardShell) cardShell.hidden = !isCompatible;
        const isUnavailable = isCompatible && (state.disabled || (variant && !variant.available));
        card.classList.toggle('is-disabled', isUnavailable);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        card.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
        card.dataset.packageVariantId = variant?.id || '';
        card.dataset.packageSku = variant?.sku || '';
        this.renderCard(card, variant || {}, config, isActive);

        if (isActive && variant) {
          activeVariant = variant;
        }
      });

      const variantToSync = currentVariant
        || activeVariant
        || this.getCurrentVariant?.()
        || this.getVariantForValue(currentValue);

      if (variantToSync) {
        document.querySelectorAll('opt-product-sticky-atc').forEach((sticky) => {
          sticky.setVariant?.(variantToSync);
        });
      }

      this.notifyChange({
        reason: 'sync',
        variant: variantToSync || null
      });
    }

    notifyChange(detail = {}) {
      this.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('opt:package-selector-change', {
        detail: {
          source: this,
          ...detail
        }
      }));
    }
  }

  customElements.define('opt-product-package-selector', OptProductPackageSelector);
}

if (!customElements.get('opt-product-sticky-atc')) {
  class OptProductStickyAtc extends HTMLElement {
    connectedCallback() {
      if (document.body && !this.parentElement?.classList.contains('opt-product-sticky-atc-portal')) {
        let portal = document.querySelector('.opt-product-sticky-atc-portal');
        if (!portal) {
          portal = document.createElement('div');
          portal.className = 'thb-product-detail opt-product-sticky-atc-portal';
          document.body.appendChild(portal);
        }
        portal.appendChild(this);
        return;
      }

      if (this.isInitialized) return;
      this.isInitialized = true;

      this.sectionId = this.dataset.section || '';
      this.productData = this.getJson('[data-opt-sticky-atc-product]');
      this.quantityInput = this.querySelector('[data-opt-sticky-atc-quantity]');
      this.quantityButtons = Array.from(this.querySelectorAll('.opt-product-sticky-atc__quantity-button'));
      this.titleElement = this.querySelector('[data-opt-sticky-atc-title]');
      this.details = this.querySelector('[data-opt-sticky-atc-details]');
      this.toggleButton = this.querySelector('[data-opt-sticky-atc-toggle]');
      this.arrow = this.querySelector('.opt-product-sticky-atc__arrow');
      this.price = this.querySelector('[data-opt-sticky-atc-price]');
      this.compare = this.querySelector('[data-opt-sticky-atc-compare]');
      this.saved = this.querySelector('[data-opt-sticky-atc-saved]');
      this.savedAmount = this.querySelector('[data-opt-sticky-atc-saved-amount]');
      this.addButton = this.querySelector('[data-opt-sticky-atc-add]');
      this.addButtonText = this.addButton?.querySelector('[data-opt-sticky-atc-button-text]');
      this.stickyForm = this.querySelector('[data-opt-sticky-atc-form]');
      this.stickyFormVariantInput = this.querySelector('[data-opt-sticky-atc-form-variant]');
      this.stickyFormQuantityInput = this.querySelector('[data-opt-sticky-atc-form-quantity]');
      this.errorMessageWrapper = this.querySelector('[data-opt-sticky-atc-error-wrapper]');
      this.errorMessage = this.querySelector('[data-opt-sticky-atc-error-message]');
      this.dynamicButton = this.querySelector('[data-opt-sticky-atc-dynamic]');
      this.nativePaymentButton = this.querySelector('[data-opt-sticky-atc-native-payment]');
      this.onChange = this.onChange.bind(this);
      this.onQuantityInput = this.onQuantityInput.bind(this);
      this.onQuantityButtonClick = this.onQuantityButtonClick.bind(this);
      this.stopQuantityInputClick = this.stopQuantityInputClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onTogetherOfferChange = this.onTogetherOfferChange.bind(this);
      this.onCarePlanChange = this.onCarePlanChange.bind(this);
      this.onPackageSelectorChange = this.onPackageSelectorChange.bind(this);
      this.onTogetherOfferInteraction = this.onTogetherOfferInteraction.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onAddClick = this.onAddClick.bind(this);
      this.onDynamicClick = this.onDynamicClick.bind(this);
      this.onResize = this.onResize.bind(this);

      this.addEventListener('change', this.onChange);
      this.quantityInput?.addEventListener('click', this.stopQuantityInputClick);
      this.quantityInput?.addEventListener('input', this.onQuantityInput);
      this.quantityInput?.addEventListener('change', this.onQuantityInput);
      this.quantityButtons.forEach((button) => button.addEventListener('click', this.onQuantityButtonClick));
      document.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onChange);
      document.addEventListener('product:variant-change', this.onVariantChange);
      document.addEventListener('opt:together-offer-change', this.onTogetherOfferChange);
      document.addEventListener('opt:care-plan-change', this.onCarePlanChange);
      document.addEventListener('opt:package-selector-change', this.onPackageSelectorChange);
      document.addEventListener('click', this.onTogetherOfferInteraction, true);
      document.addEventListener('input', this.onTogetherOfferInteraction, true);
      document.addEventListener('change', this.onTogetherOfferInteraction, true);
      this.toggleButton?.addEventListener('click', this.onToggle);
      this.addButton?.addEventListener('click', this.onAddClick);
      this.dynamicButton?.addEventListener('click', this.onDynamicClick);
      window.addEventListener('resize', this.onResize);

      this.defaultAddButtonText = this.addButtonText?.textContent?.trim() || this.dataset.addToCartText || '';
      if (this.defaultAddButtonText) {
        this.dataset.addToCartText = this.defaultAddButtonText;
      }

      this.syncQuantityFromMain();
      requestAnimationFrame(() => this.sync());
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;
      this.isInitialized = false;

      this.removeEventListener('change', this.onChange);
      this.quantityInput?.removeEventListener('click', this.stopQuantityInputClick);
      this.quantityInput?.removeEventListener('input', this.onQuantityInput);
      this.quantityInput?.removeEventListener('change', this.onQuantityInput);
      this.quantityButtons?.forEach((button) => button.removeEventListener('click', this.onQuantityButtonClick));
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onChange);
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.removeEventListener('opt:together-offer-change', this.onTogetherOfferChange);
      document.removeEventListener('opt:care-plan-change', this.onCarePlanChange);
      document.removeEventListener('opt:package-selector-change', this.onPackageSelectorChange);
      document.removeEventListener('click', this.onTogetherOfferInteraction, true);
      document.removeEventListener('input', this.onTogetherOfferInteraction, true);
      document.removeEventListener('change', this.onTogetherOfferInteraction, true);
      this.toggleButton?.removeEventListener('click', this.onToggle);
      this.addButton?.removeEventListener('click', this.onAddClick);
      this.dynamicButton?.removeEventListener('click', this.onDynamicClick);
      window.removeEventListener('resize', this.onResize);
    }

    getJson(selector) {
      const script = this.querySelector(selector);
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error(error);
        return {};
      }
    }

    getProductScope() {
      return document.getElementById('opt-main-product') || this.closest('.thb-product-detail') || document;
    }

    getProductForm() {
      return document.getElementById(`product-form-${this.sectionId}`);
    }

    getStickyForm() {
      return this.stickyForm || this.querySelector('[data-opt-sticky-atc-form]');
    }

    getAddToCartLimit() {
      const scope = document.getElementById('opt-main-product') || this.closest('.thb-product-detail') || document;
      const limit = Number(scope?.dataset?.addToCartLimit || 5);
      return Number.isFinite(limit) && limit > 0 ? limit : 5;
    }

    getMainQuantityInput() {
      const form = this.getProductForm();
      const id = form.getAttribute("id") ? form.getAttribute("id") : form.id
      if (!form) return null;

      return Array.from(document.querySelectorAll(`[name="quantity"][form="${id}"], #${id} [name="quantity"]`)).find((input) => {
        return input !== this.quantityInput && input.offsetParent !== null;
      }) || null;
    }

    clampQuantity(value) {
      const quantity = Number.parseInt(value, 10);
      if (!Number.isFinite(quantity)) return 1;
      return Math.min(Math.max(quantity, 1), this.getAddToCartLimit());
    }

    getQuantity() {
      const value = this.quantityInput?.value || this.getMainQuantityInput()?.value || 1;
      return this.clampQuantity(value);
    }

    syncQuantityFromMain() {
      const mainQuantity = this.getMainQuantityInput();
      if (mainQuantity && this.quantityInput) {
        this.quantityInput.value = this.clampQuantity(mainQuantity.value || this.quantityInput.value || 1);
      }
      this.syncQuantityControls();
    }

    syncMainQuantity() {
      const mainQuantity = this.getMainQuantityInput();
      if (!mainQuantity || !this.quantityInput) return;
      const quantity = this.clampQuantity(this.quantityInput.value);
      if (String(mainQuantity.value) === String(quantity)) return;

      mainQuantity.value = quantity;
      mainQuantity.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }

    syncQuantityControls() {
      if (!this.quantityInput) return;

      const quantity = this.clampQuantity(this.quantityInput.value);
      const limit = this.getAddToCartLimit();
      this.quantityInput.value = quantity;
      this.quantityInput.min = 1;
      this.quantityInput.max = limit;
      this.quantityInput.dataset.min = '1';
      this.quantityInput.dataset.max = String(limit);

      const quantitySelector = this.quantityInput.closest('quantity-selector') || this;
      const minus = quantitySelector.querySelector('.minus, .opt-together-offer__quantity-button--minus');
      const plus = quantitySelector.querySelector('.plus, .opt-product-sticky-atc__quantity-button:not(.minus), .opt-together-offer__quantity-button:not(.opt-together-offer__quantity-button--minus)');

      if (minus) {
        const isDisabled = quantity <= 1;
        minus.disabled = isDisabled;
        minus.classList.toggle('disabled', isDisabled);
        minus.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      }

      if (plus) {
        const isDisabled = quantity >= limit;
        plus.disabled = isDisabled;
        plus.classList.toggle('disabled', isDisabled);
        plus.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      }
    }

    syncStickyForm(variant = this.getSelectedVariant()) {
      const quantity = this.getQuantity();

      if (this.stickyFormVariantInput && variant?.id) {
        this.stickyFormVariantInput.value = variant.id;
        this.stickyFormVariantInput.disabled = false;
      }
      if (this.stickyFormQuantityInput) {
        this.stickyFormQuantityInput.value = quantity;
      }
    }

    onQuantityInput() {
      if (!this.quantityInput) return;

      const quantity = this.clampQuantity(this.quantityInput.value);
      if (String(this.quantityInput.value) !== String(quantity)) {
        this.quantityInput.value = quantity;
      }
      this.syncQuantityControls();
      this.syncMainQuantity();
      window.requestAnimationFrame(() => this.sync());
    }

    onQuantityButtonClick() {
      window.requestAnimationFrame(() => {
        this.syncQuantityControls();
        this.syncStickyForm();
        this.sync();
      });
    }

    stopQuantityInputClick(event) {
      event.stopPropagation();
    }

    onChange(event) {
      if (event?.target === this.quantityInput) {
        this.syncMainQuantity();
      } else if (event?.target === this.getMainQuantityInput()) {
        this.syncQuantityFromMain();
      }

      window.requestAnimationFrame(() => this.sync());
    }

    onVariantChange(event) {
      const eventVariant = event.detail?.variant;
      const hasMatchingVariant = eventVariant && (this.productData.variants || []).some((variant) => String(variant.id) === String(eventVariant.id));
      if (event.detail?.sectionId && event.detail.sectionId !== this.sectionId && !hasMatchingVariant) return;
      this.currentVariant = hasMatchingVariant
        ? (this.productData.variants || []).find((variant) => String(variant.id) === String(eventVariant.id))
        : null;
      window.requestAnimationFrame(() => this.sync());
    }

    onTogetherOfferChange() {
      window.requestAnimationFrame(() => this.sync());
    }

    onCarePlanChange() {
      window.requestAnimationFrame(() => this.sync());
    }

    onPackageSelectorChange() {
      window.requestAnimationFrame(() => this.sync());
    }

    onTogetherOfferInteraction(event) {
      const target = event?.target;
      if (!target?.closest || !target.closest('opt-together-offer')) return;

      if (event.type === 'click') {
        const isRelevantClick = target.closest([
          '[data-opt-together-quantity-minus]',
          '[data-opt-together-quantity-plus]',
          '[data-opt-together-option]',
          '[data-opt-together-combo-button]',
          '.opt-together-offer__checkbox-input',
          'select.opt-together-offer__select'
        ].join(', '));
        if (!isRelevantClick) return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => this.sync());
      });
    }

    onResize() {
      window.requestAnimationFrame(() => this.updateDetailsToggle());
    }

    setVariant(variant) {
      const matchingVariant = (this.productData.variants || []).find((item) => String(item.id) === String(variant?.id));
      if (!matchingVariant) return;

      this.currentVariant = matchingVariant;
      window.requestAnimationFrame(() => this.sync());
    }

    onToggle(event) {
      event.preventDefault();
      if (!this.classList.contains('is-details-collapsible')) return;

      const expanded = this.classList.toggle('is-details-expanded');
      this.toggleButton?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    onAddClick(event) {
      event.preventDefault();
      if (this.addButton?.disabled || this.addButton?.getAttribute('aria-disabled') === 'true') return;

      this.submitFallback(this.getStickyForm() || this.getProductForm());
    }

    onDynamicClick(event) {
      event.preventDefault();
      if (this.dynamicButton?.disabled || this.dynamicButton?.getAttribute('aria-disabled') === 'true') return;

      this.submitFallback(this.getStickyForm() || this.getProductForm(), {
        redirectToCheckout: true
      });
    }

    getSelectedVariant() {
      const form = this.getProductForm();
      const variantId = form?.querySelector('[name="id"]')?.value;
      return this.currentVariant
        || (this.productData.variants || []).find((variant) => String(variant.id) === String(variantId))
        || (this.productData.variants || [])[0]
        || null;
    }

    getSelectedCareVariantId() {
      const scope = this.getProductScope();
      const careInput = scope.querySelector('opt-care-plan [data-opt-care-selected-variant-id]');
      return careInput?.value || '';
    }

    getSelectedTogetherCartItems() {
      const scope = this.getProductScope();
      const addToCartLimit = this.getAddToCartLimit();
      return Array.from(scope.querySelectorAll('opt-together-offer [data-opt-together-card]'))
        .map((card) => {
          const variantId = card.querySelector('[data-opt-together-selected-variant-id]')?.value;
          if (!variantId) return null;

          const quantity = Number(card.querySelector('[data-opt-together-quantity-input]')?.value || 1);
          return {
            id: variantId,
            quantity: Number.isFinite(quantity) ? Math.min(Math.max(quantity, 1), addToCartLimit) : 1
          };
        })
        .filter(Boolean);
    }

    getSelectedPackageGiftVariantIds() {
      const scope = this.getProductScope();
      const activeCard = scope.querySelector('opt-product-package-selector [data-package-card].is-active');

      return Array.from(activeCard?.querySelectorAll('[data-opt-package-gift][data-opt-package-gift-selected="true"] [data-opt-package-gift-variant-id]') || [])
        .map((item) => item.dataset.optPackageGiftVariantId || item.value)
        .filter(Boolean);
    }

    getFallbackAddOnItems(quantity) {
      const items = [];
      const careVariantId = this.getSelectedCareVariantId();

      if (careVariantId) {
        items.push({
          id: careVariantId,
          quantity
        });
      }

      this.getSelectedTogetherCartItems().forEach((item) => {
        items.push(item);
      });

      this.getSelectedPackageGiftVariantIds().forEach((variantId) => {
        items.push({
          id: variantId,
          quantity
        });
      });

      return items;
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    buildFallbackFormData(sourceForm = null) {
      let formData = sourceForm ? new FormData(sourceForm) : new FormData();
      const variant = this.getSelectedVariant();
      const quantity = String(this.getQuantity());

      if (!formData.get('id') && variant?.id) {
        formData.append('id', variant.id);
      }
      if (!formData.get('quantity')) {
        formData.append('quantity', quantity);
      }

      const addOnItems = this.getFallbackAddOnItems(quantity);
      if (addOnItems.length) {
        const addOnFormData = new FormData();
        addOnFormData.append('items[0][id]', formData.get('id'));
        addOnFormData.append('items[0][quantity]', formData.get('quantity') || quantity);

        addOnItems.forEach((item, index) => {
          addOnFormData.append(`items[${index + 1}][id]`, item.id);
          addOnFormData.append(`items[${index + 1}][quantity]`, item.quantity || 1);
        });

        for (const [key, value] of formData.entries()) {
          if (value === '') continue;

          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch) {
            addOnFormData.append(`items[0][properties][${propertyMatch[1]}]`, value);
          } else if (key === 'selling_plan') {
            addOnFormData.append('items[0][selling_plan]', value);
          }
        }

        formData = addOnFormData;
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      return formData;
    }

    setSubmitLoading(isLoading) {
      [this.addButton, this.dynamicButton].filter(Boolean).forEach((submitButton) => {
        submitButton.classList.toggle('loading', isLoading);
        if (isLoading) {
          submitButton.setAttribute('aria-disabled', true);
        } else {
          submitButton.removeAttribute('aria-disabled');
        }
      });
    }

    submitFallback(sourceForm = null, options = {}) {
      const formData = this.buildFallbackFormData(sourceForm);
      const productVariantId = formData.get('id') || formData.get('items[0][id]');
      if (!productVariantId) return;

      this.handleErrorMessage();
      this.setSubmitLoading(true);

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'sticky-product-form',
              productVariantId,
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description || response.message);
            return;
          }

          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
          if (options.redirectToCheckout) {
            window.location.href = '/checkout';
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.setSubmitLoading(false));
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !parsedState.sections?.[section.section]) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent?.();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      document.getElementById('Search-Drawer')?.classList.remove('active');
      document.getElementById('Cart-Drawer')?.open?.();
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML || '';
    }

    handleErrorMessage(errorMessage = false) {
      if (!this.errorMessageWrapper || !this.errorMessage) return;

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    formatMoney(cents) {
      const amount = Number(cents || 0);
      let moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      if (!/\{\{\s*\w+\s*\}\}/.test(moneyFormat)) {
        moneyFormat = this.dataset.currencyCode ? `${this.dataset.currencyCode} {{amount}}` : '{{amount}}';
      }
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(amount, moneyFormat || '{{amount}}').replace(' USD', '');
      }

      const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
        if (!Number.isFinite(number)) return '0';
        const parts = (number / 100).toFixed(precision).split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      };

      const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const placeholder = placeholderMatch?.[1] || 'amount';
      let value = formatWithDelimiters(amount, 2);

      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(amount, 2, "'", '.');
          break;
      }

      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    addLine(lines, text, quantity, quantityApplies = true) {
      if (!text) return;
      lines.push(quantityApplies && quantity > 1 ? `${text} ×${quantity}` : text);
    }

    getMainVariantDetailOptions(variant) {
      const options = (variant?.options || []).filter(Boolean);
      const hasOnlyDefaultVariant = (this.productData.variants || []).length === 1
        && String(variant?.title || '').trim().toLowerCase() === 'default title'
        && options.length <= 1
        && (!options.length || String(options[0]).trim().toLowerCase() === 'default title');

      return hasOnlyDefaultVariant ? [] : options;
    }

    updateDetailsToggle() {
      if (!this.details || !this.toggleButton) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const hasDetails = Boolean(this.details.textContent.trim());
      let isCollapsible = false;

      const availableWidth = this.toggleButton.clientWidth || this.details.clientWidth;

      if (isMobile && hasDetails && availableWidth > 0) {
        const styles = window.getComputedStyle(this.details);
        const clone = this.details.cloneNode(true);

        clone.style.position = 'absolute';
        clone.style.visibility = 'hidden';
        clone.style.pointerEvents = 'none';
        clone.style.height = '1px';
        clone.style.maxHeight = '1px';
        clone.style.overflow = 'visible';
        clone.style.display = 'block';
        clone.style.width = 'auto';
        clone.style.maxWidth = 'none';
        clone.style.whiteSpace = 'nowrap';
        clone.style.fontFamily = styles.fontFamily;
        clone.style.fontSize = styles.fontSize;
        clone.style.fontWeight = styles.fontWeight;
        clone.style.webkitLineClamp = 'unset';
        clone.style.webkitBoxOrient = 'initial';
        clone.style.left = '-9999px';
        clone.style.top = '0';

        document.body.appendChild(clone);
        isCollapsible = clone.scrollWidth > availableWidth + 1;
        clone.remove();
      }

      this.classList.toggle('is-details-collapsible', isCollapsible);
      if (this.arrow) {
        this.arrow.hidden = !isCollapsible;
      }
      if (!isCollapsible) {
        this.classList.remove('is-details-expanded');
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }
    }

    getCareSelection(quantity) {
      const scope = this.getProductScope();
      const input = scope.querySelector('opt-care-plan .opt-care-plan__radio:checked');
      if (!input?.value) return {
        price: 0,
        compare: 0,
        lines: []
      };

      const price = Number(input.dataset.carePriceCents || 0) * quantity;
      const compareBase = Number(input.dataset.careComparePriceCents || 0) || Number(input.dataset.carePriceCents || 0);
      return {
        price,
        compare: compareBase * quantity,
        lines: [quantity > 1 ? `${input.dataset.careTitle || ''} ×${quantity}` : input.dataset.careTitle || '']
      };
    }

    getTogetherSelections() {
      const scope = this.getProductScope();
      const addToCartLimit = this.getAddToCartLimit();
      const selections = [];

      scope.querySelectorAll('opt-together-offer [data-opt-together-card]').forEach((card) => {
        const variantId = card.querySelector('[data-opt-together-selected-variant-id]')?.value;
        if (!variantId) return;
        const quantity = Number(card.querySelector('[data-opt-together-quantity-input]')?.value || 1);

        const script = card.querySelector('[data-opt-together-variants]');
        let variants = [];
        try {
          variants = JSON.parse(script?.textContent || '[]');
        } catch (error) {
          variants = [];
        }
        const variant = variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;

        selections.push({
          price: Number(variant.priceCents || 0),
          compare: Number(variant.comparePriceCents || variant.priceCents || 0),
          quantity: Number.isFinite(quantity) ? Math.min(Math.max(quantity, 1), addToCartLimit) : 1,
          title: variant.title || card.querySelector('.opt-together-offer__product-title')?.textContent?.trim() || ''
        });
      });

      return selections;
    }

    getPackageSelections(quantity) {
      const scope = this.getProductScope();
      const selector = scope.querySelector('opt-product-package-selector');
      if (!selector?.data) return [];
      const activeCard = selector.querySelector('[data-package-card].is-active');

      return Array.from(activeCard?.querySelectorAll('[data-opt-package-gift][data-opt-package-gift-selected="true"] [data-opt-package-gift-variant-id]') || []).map((element) => {
        const variantId = element.dataset.optPackageGiftVariantId || element.value;
        const discount = Math.min(Math.max(Number(element.dataset.optPackageGiftDiscount || 0), 0), 100);
        let selectedVariant = null;
        let giftTitle = '';

        (selector.data.gifts || []).forEach((gift) => {
          const variant = (gift.variants || []).find((item) => String(item.id) === String(variantId));
          if (variant) {
            selectedVariant = variant;
            giftTitle = gift.title || variant.title || '';
          }
        });

        if (!selectedVariant) return null;
        const unitPrice = Math.round(Number(selectedVariant.priceCents || 0) * (100 - discount) / 100);
        return {
          price: unitPrice * quantity,
          compare: Number(selectedVariant.priceCents || 0) * quantity,
          title: quantity > 1 ? `${giftTitle} ×${quantity}` : giftTitle
        };
      }).filter(Boolean);
    }

    sync() {
      const quantity = this.getQuantity();
      const variant = this.getSelectedVariant();
      if (!variant) return;
      this.syncQuantityControls();
      this.syncStickyForm(variant);

      const lines = [];
      this.getMainVariantDetailOptions(variant).forEach((option) => this.addLine(lines, option, quantity, true));

      if (this.titleElement) {
        this.titleElement.textContent = quantity > 1 ? `${this.productData.title || ''} ×${quantity}` : this.productData.title || '';
      }

      let totalPrice = Number(variant.priceCents || 0) * quantity;
      let totalCompare = Number(variant.comparePriceCents || variant.priceCents || 0) * quantity;

      const care = this.getCareSelection(quantity);
      totalPrice += care.price;
      totalCompare += care.compare || care.price;
      care.lines.forEach((line) => this.addLine(lines, line, quantity, false));

      this.getTogetherSelections().forEach((item) => {
        totalPrice += item.price * item.quantity;
        totalCompare += (item.compare || item.price) * item.quantity;
        this.addLine(lines, item.title, item.quantity, true);
      });

      this.getPackageSelections(quantity).forEach((item) => {
        totalPrice += item.price;
        totalCompare += item.compare || item.price;
        this.addLine(lines, item.title, quantity, true);
      });

      if (this.details) {
        this.details.textContent = lines.filter(Boolean).join('  |  ');
        window.requestAnimationFrame(() => this.updateDetailsToggle());
      }

      if (this.price) {
        setOptMoneyHtml(this.price, this.formatMoney(totalPrice));
      }

      const hasSavings = totalCompare > totalPrice;
      if (this.compare) {
        setOptMoneyHtml(this.compare, hasSavings ? this.formatMoney(totalCompare) : '');
        this.compare.hidden = !hasSavings;
      }
      if (this.saved) {
        this.saved.hidden = !hasSavings;
      }
      if (this.savedAmount) {
        setOptMoneyHtml(this.savedAmount, hasSavings ? this.formatMoney(totalCompare - totalPrice) : '');
      }

      if (this.addButton) {
        const isUnavailable = variant.available === false;
        this.addButton.disabled = isUnavailable;
        this.addButton.classList.toggle('sold-out', isUnavailable);
        if (this.dynamicButton) {
          this.dynamicButton.disabled = isUnavailable;
          this.dynamicButton.classList.toggle('sold-out', isUnavailable);
        }
        if (this.nativePaymentButton) {
          this.nativePaymentButton.hidden = isUnavailable;
        }

        if (this.addButtonText) {
          if (isUnavailable) {
            this.addButtonText.textContent = this.dataset.soldOutText || 'Sold out';
          } else if ((this.dataset.productTemplate || '').includes('pre-order')) {
            this.addButtonText.textContent = this.dataset.preOrderText || 'Pre-order';
          } else {
            this.addButtonText.textContent = this.defaultAddButtonText || this.dataset.addToCartText || this.addButtonText.textContent;
          }
        }
      }
    }
  }

  customElements.define('opt-product-sticky-atc', OptProductStickyAtc);
}

if (!window.optProductPopupModalInit) {
  window.optProductPopupModalInit = true;

  const closeOptProductPopupModal = (modal) => {
    if (!modal) return;

    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
      document.documentElement.classList.remove('opt-product-popup-modal-open');
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-opt-product-popup-open]');

    if (opener) {
      const selector = opener.dataset.optProductPopupOpen;
      const modal = selector ? document.querySelector(selector) : null;

      if (modal) {
        event.preventDefault();

        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }

        document.documentElement.classList.add('opt-product-popup-modal-open');
      }

      return;
    }

    const closeButton = event.target.closest('[data-opt-product-popup-close]');

    if (closeButton) {
      event.preventDefault();
      closeOptProductPopupModal(closeButton.closest('[data-opt-product-popup-modal]'));
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-opt-product-popup-modal]')) {
      closeOptProductPopupModal(event.target);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches && event.target.matches('[data-opt-product-popup-modal]')) {
      document.documentElement.classList.remove('opt-product-popup-modal-open');
    }
  }, true);
}

if (!customElements.get('opt-care-plan')) {
  class OptCarePlan extends HTMLElement {
    connectedCallback() {
      this.hiddenInput = this.querySelector('[data-opt-care-selected-variant-id]');
      this.radios = Array.from(this.querySelectorAll('.opt-care-plan__radio'));
      this.changeHandler = () => this.sync(true);

      this.radios.forEach((radio) => {
        radio.addEventListener('change', this.changeHandler);
      });

      this.sync();
    }

    disconnectedCallback() {
      this.radios.forEach((radio) => {
        radio.removeEventListener('change', this.changeHandler);
      });
    }

    sync(notify = false) {
      const selectedRadio = this.radios.find((radio) => radio.checked);
      const selectedVariantId = selectedRadio?.value || '';

      if (this.hiddenInput) {
        this.hiddenInput.value = selectedVariantId;
      }

      this.querySelectorAll('.opt-care-plan__item').forEach((item) => {
        item.classList.toggle('is-selected', item.contains(selectedRadio));
      });

      if (notify) {
        this.dispatchEvent(new Event('change', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('opt:care-plan-change', {
          detail: {
            source: this,
            variantId: selectedVariantId,
            radio: selectedRadio || null
          }
        }));
      }
    }
  }

  customElements.define('opt-care-plan', OptCarePlan);
}

if (!customElements.get('opt-financing-benefits')) {
  class OptFinancingBenefits extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.opt-financing-benefits__button'));
      this.textTargets = Array.from(this.querySelectorAll('[data-financing-benefits-text]'));
      this.onButtonClick = this.onButtonClick.bind(this);
      this.hideAppSelectors = (this.dataset.financingBenefitsHideSelector || '')
        .split(/\r?\n/)
        .map((selector) => selector.trim())
        .filter(Boolean);
      this.syncExternalContent = this.syncExternalContent.bind(this);

      this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick));
      this.syncExternalContent();

      if (this.hideAppSelectors.length || this.textTargets.some((textTarget) => textTarget.dataset.financingBenefitsTextSelector?.trim())) {
        this.externalContentObserver = new MutationObserver(this.syncExternalContent);
        this.externalContentObserver.observe(document.body, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => button.removeEventListener('click', this.onButtonClick));
      this.externalContentObserver?.disconnect();
    }

    syncExternalContent() {
      this.applyHideAppSelector();
      this.applyTextSourceSelectors();
    }

    applyHideAppSelector() {
      if (!this.hideAppSelectors.length) return;

      this.hideAppSelectors.forEach((selector) => {
        let targets = [];
        try {
          targets = Array.from(document.querySelectorAll(selector));
        } catch (error) {
          targets = [];
        }

        targets.forEach((target) => {
          target.style.setProperty('display', 'none', 'important');
        });
      });
    }

    getTextReplacementRules(replacements) {
      return (replacements || '')
        .split(/\r?\n/)
        .map((line) => {
          const separatorIndex = line.indexOf('|');
          if (separatorIndex < 0) return null;

          const search = line.slice(0, separatorIndex);
          const replacement = line.slice(separatorIndex + 1);
          if (!search) return null;

          return {
            search,
            replacement
          };
        })
        .filter(Boolean);
    }

    applyTextReplacementRules(text, rules) {
      return rules.reduce((currentText, rule) => currentText.split(rule.search).join(rule.replacement), text);
    }

    getTextSourceHtml(target, rules = []) {
      if (!target) return '';

      const clone = target.cloneNode(true);
      if (clone.matches('a, button')) {
        return '';
      }
      clone.querySelectorAll('a, button').forEach((element) => element.remove());

      const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });

      const textParts = [];
      while (walker.nextNode()) {
        const text = walker.currentNode.textContent.replace(/\s+/g, ' ').trim();
        if (text) {
          textParts.push(text);
        }
      }

      if (!textParts.length) {
        return '';
      }

      return this.applyTextReplacementRules(textParts.join(' '), rules);
    }

    applyTextSourceSelectors() {
      this.textTargets.forEach((textTarget) => {
        const selector = (textTarget.dataset.financingBenefitsTextSelector || '').trim();
        const replacementRules = this.getTextReplacementRules(textTarget.dataset.financingBenefitsTextReplacements || '');
        const defaultText = this.applyTextReplacementRules(textTarget.dataset.financingBenefitsDefaultText || '', replacementRules);

        if (!selector) {
          if (textTarget.textContent !== defaultText) {
            textTarget.textContent = defaultText;
          }
          return;
        }

        const target = this.findTarget(selector);
        const sourceHtml = this.getTextSourceHtml(target, replacementRules);

        if (sourceHtml) {
          if (textTarget.innerHTML !== sourceHtml) {
            textTarget.innerHTML = sourceHtml;
          }
        } else {
          if (textTarget.textContent !== defaultText) {
            textTarget.textContent = defaultText;
          }
        }
      });
    }

    getClickableTarget(target) {
      const clickableSelector = 'button, a, input, select, textarea, [role="button"], [tabindex]';

      if (!target) return null;

      if (target.matches(clickableSelector)) {
        return target;
      }

      const lightDomTarget = target.querySelector(clickableSelector);
      if (lightDomTarget) {
        return lightDomTarget;
      }

      if (target.shadowRoot) {
        const shadowTarget = target.shadowRoot.querySelector(clickableSelector);
        if (shadowTarget) {
          return shadowTarget;
        }
      }

      const shadowHosts = Array.from(target.querySelectorAll('*')).filter((element) => element.shadowRoot);
      for (const shadowHost of shadowHosts) {
        const shadowTarget = shadowHost.shadowRoot.querySelector(clickableSelector);
        if (shadowTarget) {
          return shadowTarget;
        }
      }

      return null;
    }

    findTarget(selector) {
      let target = null;

      try {
        target = document.querySelector(selector);
      } catch (error) {
        target = null;
      }

      if (target) {
        return target;
      }

      const selectorParts = selector.split(/\s+/).filter(Boolean);
      if (selectorParts.length < 2) {
        return null;
      }

      const shadowSelector = selectorParts.pop();
      const scopeSelector = selectorParts.join(' ');

      let scopes = [];
      try {
        scopes = Array.from(document.querySelectorAll(scopeSelector));
      } catch (error) {
        scopes = [];
      }

      for (const scope of scopes) {
        if (scope.shadowRoot) {
          const shadowTarget = scope.shadowRoot.querySelector(shadowSelector);
          if (shadowTarget) {
            return shadowTarget;
          }
        }

        const shadowHosts = Array.from(scope.querySelectorAll('*')).filter((element) => element.shadowRoot);
        for (const shadowHost of shadowHosts) {
          const shadowTarget = shadowHost.shadowRoot.querySelector(shadowSelector);
          if (shadowTarget) {
            return shadowTarget;
          }
        }
      }

      return null;
    }

    onButtonClick(event) {
      event.preventDefault();

      const selector = (
        event.currentTarget.getAttribute('data-financing-benefits-selector')
        || this.dataset.financingBenefitsDefaultSelector
        || ''
      ).trim();

      if (selector) {
        const target = this.findTarget(selector);
        const clickableTarget = this.getClickableTarget(target);

        if (clickableTarget) {
          clickableTarget.click();
          return;
        }
      }

      this.dispatchEvent(new CustomEvent('opt-financing-benefits:open-modal', {
        bubbles: true,
        detail: {
          sectionId: this.dataset.section || '',
          selector
        }
      }));
    }
  }

  customElements.define('opt-financing-benefits', OptFinancingBenefits);
}

if (!customElements.get('opt-together-offer')) {
  class OptTogetherOffer extends HTMLElement {
    constructor() {
      super();
      this.closeAllCombos = this.closeAllCombos.bind(this);
      this.onQuantityClickCapture = this.onQuantityClickCapture.bind(this);
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-opt-together-card]'));
      this.addEventListener('click', this.onQuantityClickCapture, true);

      this.cards.forEach((card) => {
        const checkbox = card.querySelector('.opt-together-offer__checkbox-input');
        const selects = Array.from(card.querySelectorAll('select.opt-together-offer__select'));
        const comboButton = card.querySelector('[data-opt-together-combo-button]');
        const optionButtons = Array.from(card.querySelectorAll('[data-opt-together-option]'));
        const quantityInput = card.querySelector('[data-opt-together-quantity-input]');
        const quantityMinus = card.querySelector('[data-opt-together-quantity-minus]');
        const quantityPlus = card.querySelector('[data-opt-together-quantity-plus]');

        if (checkbox) {
          checkbox.addEventListener('change', () => this.syncCard(card, true));
        }

        selects.forEach((select) => {
          select.addEventListener('click', (event) => event.stopPropagation());
          select.addEventListener('change', () => this.syncCard(card, true));
        });

        if (quantityInput) {
          quantityInput.addEventListener('click', (event) => event.stopPropagation());
          quantityInput.addEventListener('input', () => this.setQuantity(card, quantityInput.value, true));
          quantityInput.addEventListener('change', () => this.setQuantity(card, quantityInput.value, true));
        }

        if (quantityMinus) {
          quantityMinus.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.stepQuantity(card, -1);
          });
        }

        if (quantityPlus) {
          quantityPlus.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.stepQuantity(card, 1);
          });
        }

        if (comboButton) {
          comboButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleCombo(card);
          });
        }

        optionButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectComboOption(card, button);
          });
        });

        this.syncCard(card);
      });

      document.addEventListener('click', this.closeAllCombos);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onQuantityClickCapture, true);
      document.removeEventListener('click', this.closeAllCombos);
    }

    onQuantityClickCapture(event) {
      const button = event.target.closest('[data-opt-together-quantity-minus], [data-opt-together-quantity-plus]');
      if (!button || !this.contains(button) || button.disabled) return;

      const card = button.closest('[data-opt-together-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.stepQuantity(card, button.matches('[data-opt-together-quantity-minus]') ? -1 : 1);
    }

    closeAllCombos() {
      this.cards?.forEach((card) => this.setComboOpen(card, false));
    }

    getVariants(card) {
      const script = card.querySelector('[data-opt-together-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    getSelectedOptions(card) {
      const optionButtons = Array.from(card.querySelectorAll('[data-opt-together-option].is-selected'));

      if (optionButtons.length) {
        return optionButtons
          .sort((first, second) => Number(first.dataset.optionIndex) - Number(second.dataset.optionIndex))
          .map((button) => button.dataset.optionValue);
      }

      return Array.from(card.querySelectorAll('select.opt-together-offer__select')).map((select) => select.value);
    }

    setComboOpen(card, isOpen) {
      const combo = card.querySelector('[data-opt-together-combo]');
      const button = card.querySelector('[data-opt-together-combo-button]');
      if (!combo || !button) return;

      combo.classList.toggle('is-open', isOpen);
      card.classList.toggle('is-combo-open', isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggleCombo(card) {
      const combo = card.querySelector('[data-opt-together-combo]');
      const isOpen = !combo?.classList.contains('is-open');

      this.cards.forEach((item) => {
        if (item !== card) this.setComboOpen(item, false);
      });
      this.setComboOpen(card, isOpen);
    }

    selectComboOption(card, button) {
      const optionIndex = button.dataset.optionIndex;
      const groupButtons = Array.from(card.querySelectorAll(`[data-opt-together-option][data-option-index="${optionIndex}"]`));

      groupButtons.forEach((item) => {
        const isSelected = item === button;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.syncCard(card, true);
      this.setComboOpen(card, false);
    }

    getSelectedVariant(card) {
      const variants = this.getVariants(card);
      const selectedOptions = this.getSelectedOptions(card);

      if (!selectedOptions.length) {
        return variants[0] || null;
      }

      return variants.find((variant) => {
        return selectedOptions.every((option, index) => variant.options[index] === option);
      }) || variants[0] || null;
    }

    getAddToCartLimit() {
      const scope = this.closest('.thb-product-detail') || document.getElementById('opt-main-product') || document;
      const limit = Number(scope?.dataset?.addToCartLimit || 5);
      return Number.isFinite(limit) && limit > 0 ? limit : 5;
    }

    clampQuantity(value) {
      const quantity = Number.parseInt(value, 10);
      if (!Number.isFinite(quantity)) return 1;
      return Math.min(Math.max(quantity, 1), this.getAddToCartLimit());
    }

    getQuantity(card) {
      const input = card.querySelector('[data-opt-together-quantity-input]');
      return input ? this.clampQuantity(input.value) : 1;
    }

    setQuantity(card, value, notify = false) {
      const input = card.querySelector('[data-opt-together-quantity-input]');
      if (!input) return;

      const quantity = this.clampQuantity(value);
      input.value = quantity;
      this.syncQuantityControls(card);

      if (notify) {
        this.notifyChange();
      }
    }

    stepQuantity(card, step) {
      this.setQuantity(card, this.getQuantity(card) + step, true);
    }

    syncQuantityControls(card) {
      const input = card.querySelector('[data-opt-together-quantity-input]');
      if (!input) return;

      const quantity = this.clampQuantity(input.value);
      input.value = quantity;
      input.min = 1;
      input.max = this.getAddToCartLimit();
      input.dataset.min = '1';
      input.dataset.max = String(this.getAddToCartLimit());
      const minus = card.querySelector('[data-opt-together-quantity-minus]');
      const plus = card.querySelector('[data-opt-together-quantity-plus]');
      if (minus) minus.disabled = quantity <= 1;
      if (plus) plus.disabled = quantity >= this.getAddToCartLimit();
    }

    syncCard(card, notify = false) {
      const checkbox = card.querySelector('.opt-together-offer__checkbox-input');
      const hiddenInput = card.querySelector('[data-opt-together-selected-variant-id]');
      const variant = this.getSelectedVariant(card);
      const isSelected = Boolean(checkbox?.checked && variant);

      card.classList.toggle('is-selected', isSelected);

      if (hiddenInput) {
        hiddenInput.value = isSelected ? variant.id : '';
      }

      const price = card.querySelector('[data-opt-together-price]');
      const compare = card.querySelector('[data-opt-together-compare]');
      const image = card.querySelector('[data-opt-together-image]');

      if (price && variant?.price) setOptMoneyHtml(price, variant.price);
      if (compare) {
        setOptMoneyHtml(compare, variant?.comparePrice || '');
        compare.hidden = !variant?.comparePrice;
      }
      if (image && variant?.image) image.src = variant.image;

      const comboLabel = card.querySelector('[data-opt-together-combo-label]');
      if (comboLabel && variant?.options?.length) {
        comboLabel.textContent = variant.options.join(' / ');
      }

      const optionButtons = Array.from(card.querySelectorAll('[data-opt-together-option]'));
      if (optionButtons.length && variant?.options?.length) {
        optionButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const isSelected = variant.options[optionIndex] === button.dataset.optionValue;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      this.syncQuantityControls(card);

      if (notify) {
        this.notifyChange();
      }
    }

    notifyChange() {
      this.dispatchEvent(new Event('change', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('opt:together-offer-change', {
        detail: {
          source: this
        }
      }));
    }
  }

  customElements.define('opt-together-offer', OptTogetherOffer);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.thumbnail_prev_button = this.product_container.querySelector('.product-thumbnail-navigation__button--prev');
      this.thumbnail_next_button = this.product_container.querySelector('.product-thumbnail-navigation__button--next');
      this.media_counter = this.querySelector('.product-media-counter');
      this.media_counter_current = this.media_counter ? this.media_counter.querySelector('.product-media-counter__current') : null;
      this.media_counter_total = this.media_counter ? this.media_counter.querySelector('.product-media-counter__total') : null;
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container ? this.thumbnail_container.querySelectorAll('.product-thumbnail') : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;
      this.updateMediaCounter(this.selectedIndex);

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
      this.updateMediaCounter(this.selectedIndex);
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      if (this.thumbnail_prev_button && !this.thumbnail_prev_button.dataset.productThumbnailBound) {
        this.thumbnail_prev_button.dataset.productThumbnailBound = 'true';
        this.thumbnail_prev_button.addEventListener('click', () => {
          this.selectAdjacentThumbnail(-1);
        });
      }
      if (this.thumbnail_next_button && !this.thumbnail_next_button.dataset.productThumbnailBound) {
        this.thumbnail_next_button.dataset.productThumbnailBound = 'true';
        this.thumbnail_next_button.addEventListener('click', () => {
          this.selectAdjacentThumbnail(1);
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {
        this.updateMediaCounter(index);

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        if (this.thumbnails.length) {
          const active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
          const active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });

          if (active_thumb) {
            active_thumb.classList.add('is-initial-selected');

            requestAnimationFrame(() => {
              if (active_thumb.offsetParent === null) {
                return;
              }
              const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
                windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
              active_thumb.parentElement.scrollTo({
                left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
                top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
                behavior: 'smooth'
              });
            });
          }
        }

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    selectAdjacentThumbnail(direction) {
      if (!this.thumbnail_container) {
        return;
      }

      const activeThumbnails = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
      if (!activeThumbnails.length) {
        return;
      }

      const currentThumbnail = this.thumbnail_container.querySelector('.product-thumbnail.is-initial-selected');
      const currentIndex = Math.max(activeThumbnails.indexOf(currentThumbnail), 0);
      const nextIndex = (currentIndex + direction + activeThumbnails.length) % activeThumbnails.length;
      const nextThumbnail = activeThumbnails[nextIndex];

      this.thumbnailClick(nextThumbnail, nextIndex);
    }
    updateMediaCounter(index) {
      if (!this.media_counter_current || !this.media_counter_total || !this.flkty) {
        return;
      }

      this.media_counter_current.textContent = index + 1;
      this.media_counter_total.textContent = this.flkty.cells.length;
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

(() => {
  const repairOptProductSliders = () => {
    if (!window.Flickity) return false;

    let repaired = false;

    document.querySelectorAll('#opt-main-product product-slider').forEach((slider) => {
      repaired = true;
      let flkty = Flickity.data(slider);
      const hadFlickity = Boolean(flkty);
      const productContainer = slider.closest('.thb-product-detail');
      const thumbnailContainer = productContainer?.querySelector('.product-thumbnail-container');
      const thumbnails = thumbnailContainer ? Array.from(thumbnailContainer.querySelectorAll('.product-thumbnail')) : [];
      const prevButton = slider.querySelector('.flickity-prev');
      const nextButton = slider.querySelector('.flickity-next');
      const thumbnailPrevButton = productContainer?.querySelector('.product-thumbnail-navigation__button--prev');
      const thumbnailNextButton = productContainer?.querySelector('.product-thumbnail-navigation__button--next');
      const mediaCounter = slider.querySelector('.product-media-counter');
      const mediaCounterCurrent = mediaCounter?.querySelector('.product-media-counter__current');
      const mediaCounterTotal = mediaCounter?.querySelector('.product-media-counter__total');

      if (!flkty) {
        flkty = new Flickity(slider, {
          wrapAround: true,
          pageDots: true,
          contain: true,
          adaptiveHeight: true,
          initialIndex: '.is-initial-selected',
          prevNextButtons: false,
          fade: false,
          cellSelector: '.product-images__slide.is-active'
        });

        slider.flkty = flkty;
      }

      flkty.options.draggable = true;
      flkty.updateDraggable();
      flkty.resize();

      const updateCounter = (index) => {
        if (!mediaCounterCurrent || !mediaCounterTotal) return;
        mediaCounterCurrent.textContent = index + 1;
        mediaCounterTotal.textContent = flkty.cells.length;
      };

      const getActiveThumbnails = () => thumbnails.filter((thumbnail) => thumbnail.clientWidth > 0);

      const scrollThumbnailIntoView = (thumbnail) => {
        const scroller = thumbnail?.closest('.product-thumbnail-container');
        if (!scroller) return;

        requestAnimationFrame(() => {
          const left = thumbnail.offsetLeft - (scroller.clientWidth / 2) + (thumbnail.clientWidth / 2);
          const top = thumbnail.offsetTop - (scroller.clientHeight / 2) + (thumbnail.clientHeight / 2);

          scroller.scrollTo({
            left,
            top,
            behavior: 'smooth'
          });
        });
      };

      const setActiveThumbnail = (index) => {
        const activeThumbnails = getActiveThumbnails();
        const activeThumbnail = activeThumbnails[index] || activeThumbnails[0];

        thumbnails.forEach((thumbnail) => thumbnail.classList.remove('is-initial-selected'));
        activeThumbnail?.classList.add('is-initial-selected');
        scrollThumbnailIntoView(activeThumbnail);
      };

      const selectThumbnail = (index) => {
        const activeThumbnails = getActiveThumbnails();
        const nextThumbnail = activeThumbnails[index];

        if (!nextThumbnail) return;

        thumbnails.forEach((item) => item.classList.remove('is-initial-selected'));
        nextThumbnail.classList.add('is-initial-selected');
        flkty.select(index);
        scrollThumbnailIntoView(nextThumbnail);
      };

      const selectAdjacentThumbnail = (direction) => {
        const activeThumbnails = getActiveThumbnails();
        if (!activeThumbnails.length) return;

        const currentThumbnail = thumbnailContainer?.querySelector('.product-thumbnail.is-initial-selected');
        const currentIndex = Math.max(activeThumbnails.indexOf(currentThumbnail), 0);
        const nextIndex = (currentIndex + direction + activeThumbnails.length) % activeThumbnails.length;

        selectThumbnail(nextIndex);
      };

      if (!hadFlickity && !prevButton?.dataset.optSliderNavBound) {
        prevButton?.addEventListener('click', () => flkty.previous());
        if (prevButton) prevButton.dataset.optSliderNavBound = 'true';
      }

      if (!hadFlickity && !nextButton?.dataset.optSliderNavBound) {
        nextButton?.addEventListener('click', () => flkty.next());
        if (nextButton) nextButton.dataset.optSliderNavBound = 'true';
      }

      if (!thumbnailPrevButton?.dataset.optThumbnailRepairBound) {
        thumbnailPrevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          selectAdjacentThumbnail(-1);
        });
        if (thumbnailPrevButton) thumbnailPrevButton.dataset.optThumbnailRepairBound = 'true';
      }

      if (!thumbnailNextButton?.dataset.optThumbnailRepairBound) {
        thumbnailNextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          selectAdjacentThumbnail(1);
        });
        if (thumbnailNextButton) thumbnailNextButton.dataset.optThumbnailRepairBound = 'true';
      }

      getActiveThumbnails().forEach((thumbnail, index) => {
        if (thumbnail.dataset.optThumbnailRepairBound === 'true') return;

        thumbnail.dataset.optThumbnailRepairBound = 'true';
        thumbnail.addEventListener('click', () => selectThumbnail(index));
      });

      if (slider.dataset.optSliderChangeRepaired !== 'true') {
        slider.dataset.optSliderChangeRepaired = 'true';

        flkty.on('change', (index) => {
          updateCounter(index);
          setActiveThumbnail(index);
        });
      }

      updateCounter(flkty.selectedIndex);
      setActiveThumbnail(flkty.selectedIndex);
    });

    return repaired;
  };

  const scheduleRepair = () => {
    const startedAt = Date.now();
    const timeout = 4000;

    const tick = () => {
      if (repairOptProductSliders()) return;
      if (Date.now() - startedAt > timeout) return;

      window.requestAnimationFrame(() => {
        window.setTimeout(tick, 16);
      });
    };

    tick();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRepair, {
      once: true
    });
  } else {
    scheduleRepair();
  }

  window.addEventListener('load', scheduleRepair, {
    once: true
  });
})();

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    getAddToCartLimit() {
      const scope = document.getElementById('opt-main-product') || this.closest('.thb-product-detail') || document;
      const limit = Number(scope?.dataset?.addToCartLimit || 5);
      return Number.isFinite(limit) && limit > 0 ? limit : 5;
    }

    clampQuantity(value) {
      const quantity = Number.parseInt(value, 10);
      if (!Number.isFinite(quantity)) return 1;
      return Math.min(Math.max(quantity, 1), this.getAddToCartLimit());
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);
      const productVariantId = formData.get('id');
      const addOnItems = this.getSelectedAddOnItems(formData);

      if (addOnItems.length) {
        const addOnFormData = new FormData();
        const quantity = formData.get('quantity') || 1;

        addOnFormData.append('items[0][id]', productVariantId);
        addOnFormData.append('items[0][quantity]', quantity);

        addOnItems.forEach((item, index) => {
          addOnFormData.append(`items[${index + 1}][id]`, item.id);
          addOnFormData.append(`items[${index + 1}][quantity]`, item.quantity || 1);
        });

        for (const [key, value] of formData.entries()) {
          if (value === '') continue;

          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch) {
            addOnFormData.append(`items[0][properties][${propertyMatch[1]}]`, value);
          } else if (key === 'selling_plan') {
            addOnFormData.append('items[0][selling_plan]', value);
          }
        }

        formData = addOnFormData;
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: productVariantId,
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSelectedCareVariantId() {
      const scope = this.closest('.thb-product-detail') || document;
      const careInput = scope.querySelector('opt-care-plan [data-opt-care-selected-variant-id]');

      return careInput?.value || '';
    }

    getSelectedTogetherSelections() {
      const scope = this.closest('.thb-product-detail') || document;
      const addToCartLimit = this.getAddToCartLimit();
      return Array.from(scope.querySelectorAll('opt-together-offer [data-opt-together-card]'))
        .map((card) => {
          const variantId = card.querySelector('[data-opt-together-selected-variant-id]')?.value;
          if (!variantId) return null;

          const quantity = Number(card.querySelector('[data-opt-together-quantity-input]')?.value || 1);
          return {
            id: variantId,
            quantity: Number.isFinite(quantity) ? Math.min(Math.max(quantity, 1), addToCartLimit) : 1
          };
        })
        .filter(Boolean);
    }

    getSelectedPackageGiftVariantIds() {
      const scope = this.closest('.thb-product-detail') || document;
      const activeCard = scope.querySelector('opt-product-package-selector [data-package-card].is-active');

      return Array.from(activeCard?.querySelectorAll('[data-opt-package-gift][data-opt-package-gift-selected="true"] [data-opt-package-gift-variant-id]') || [])
        .map((item) => item.dataset.optPackageGiftVariantId || item.value)
        .filter(Boolean);
    }

    getSelectedAddOnItems(formData) {
      const quantity = this.clampQuantity(formData.get('quantity') || 1);
      const items = [];
      const careVariantId = this.getSelectedCareVariantId();

      if (careVariantId) {
        items.push({
          id: careVariantId,
          quantity: quantity
        });
      }

      this.getSelectedTogetherSelections().forEach((item) => {
        items.push({
          id: item.id,
          quantity: item.quantity
        });
      });

      this.getSelectedPackageGiftVariantIds().forEach((variantId) => {
        items.push({
          id: variantId,
          quantity: quantity
        });
      });

      return items;
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer?.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (!customElements.get('launch-offer-countdown')) {
  class LaunchOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.alwaysShow = this.dataset.alwaysShow === 'true';
      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      if (this.alwaysShow) return;

      this.endTime = this.parseEndTime(this.dataset.endTime);

      this.updateCountdown();
      if (Number.isNaN(this.endTime) || this.endTime <= Date.now()) {
        this.hideExpired();
        return;
      }

      this.timer = window.setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
    }

    parseEndTime(value) {
      if (!value) {
        return NaN;
      }

      const parsed = new Date(value).getTime();
      return Number.isNaN(parsed) ? NaN : parsed;
    }

    format(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    hideExpired() {
      const block = this.closest('.opt-launch-offer-block') || this;
      block.hidden = true;
    }

    updateCountdown() {
      let remaining = Number.isNaN(this.endTime) ? 0 : this.endTime - Date.now();

      if (remaining <= 0) {
        remaining = 0;
        if (this.timer) {
          window.clearInterval(this.timer);
        }
        this.hideExpired();
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = this.format(days);
      if (this.hoursEl) this.hoursEl.textContent = this.format(hours);
      if (this.minutesEl) this.minutesEl.textContent = this.format(minutes);
      if (this.secondsEl) this.secondsEl.textContent = this.format(seconds);
    }
  }

  customElements.define('launch-offer-countdown', LaunchOfferCountdown);
}

if (!customElements.get('opt-key-features')) {
  class OptKeyFeatures extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.opt-key-features__panel');
      this.body = this.querySelector('.opt-key-features__body');
      this.content = this.querySelector('.opt-key-features__content');
      this.toggleButton = this.querySelector('.opt-key-features__toggle');
      this.collapsedHeight = parseFloat(this.dataset.collapsedHeight) || 160;
      this.openByDefault = this.dataset.openByDefault === 'true';
      this.expanded = this.openByDefault;

      if (!this.panel || !this.content || !this.toggleButton) return;

      this.toggleHandler = () => this.toggle();
      this.toggleButton.addEventListener('click', this.toggleHandler);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.content);
      }

      requestAnimationFrame(() => this.refresh());
    }

    disconnectedCallback() {
      if (this.toggleButton && this.toggleHandler) {
        this.toggleButton.removeEventListener('click', this.toggleHandler);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    refresh() {
      const wasCollapsible = this.collapsible;
      const controlsHeight = this.toggleButton.offsetHeight || 32;
      const contentHeight = this.content.scrollHeight;
      const contentOverflows = contentHeight > this.collapsedHeight + 1;

      this.collapsible = contentOverflows;
      this.classList.toggle('is-static', !this.collapsible);

      if (!this.collapsible) {
        this.expanded = true;
      } else if (wasCollapsible === false) {
        this.expanded = this.openByDefault;
      }

      this.update(false);
    }

    toggle() {
      if (!this.collapsible) return;
      this.expanded = !this.expanded;
      this.update(true);
    }

    update(animate) {
      const controlsHeight = this.toggleButton.offsetHeight || 32;
      const contentHeight = this.content.scrollHeight;
      const expandedHeight = contentHeight + controlsHeight;
      const targetHeight = !this.collapsible
        ? contentHeight
        : this.expanded
          ? expandedHeight
          : this.collapsedHeight + controlsHeight;

      this.dataset.expanded = this.expanded ? 'true' : 'false';
      this.toggleButton.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');

      if (!animate) {
        this.panel.style.transition = 'none';
        this.panel.style.height = `${targetHeight}px`;
        this.panel.offsetHeight;
        this.panel.style.transition = '';
        return;
      }

      this.panel.style.height = `${targetHeight}px`;
    }
  }

  customElements.define('opt-key-features', OptKeyFeatures);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
